import React, { useContext, useState, useRef,useEffect } from 'react';
import moment from 'moment';
import {
  CALCULATE_PREMIUM_FOR_PROPOSAL_TW,
  FINANCER_DROPDOWN_DETAILS,
  GET_BUY_MOTOR_POLICY_VAR_DETAILS,
  PREVIOUS_INSURER_COMPANY_LIST,
  FINANCIER_NAME_LIST,
  CALCULATE_PREMIUM_FOR_PROPOSAL_TWAPI,//SA975
   DOCUMENT_STATIC_DATA,
   UPLOAD_DOCUMENT,
  FINANCER_DROPDOWN_DETAILS_GCV
} from '../queries';
// import { PROPOSER_DROPDOWN_DETAIL } from '../../health/queries';
import { PROPOSER_DROPDOWN_DETAIL } from 'quanta-flows/modules/proposal/health';
import { Loading } from 'quanta-flows/modules/layout';
// import Loading from '../../../../../lib/layout/loading';
import { Error } from 'quanta-flows/modules/layout';
// import Error from '../../../../../lib/layout/error';
import { useQuery } from '@apollo/client';
import {useMutationQuery } from 'quanta-flows/modules/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { ConfigContext } from '../../../../../lib/config/ConfigProvider';
import { QuantaConfigContext } from 'quanta-flows';
import {
  useResponsiveParams,
  QuantaFormik,
  QuantaForm,
  useQuantaFormikContext,
  Text,
  MixedGridGroup,
  QuantaInput,
  QuantaSelect,
  SearchResultsModal,
  Button,
  Paper,
  InputGridGroup,
} from 'quanta-ui';
// import IconIdle from '../../../../common/icon-search-idle';
// import Parse from '../../../../../lib/intl/CurrencyFormater';
import { CurrencyFormater } from 'quanta-flows';
// import { updateBuyMotorPolicy } from '../_graphql/state';
import { updateBuyMotorPolicy } from 'quanta-flows/modules/proposal/motor/state';
import { useFetchQuery } from 'quanta-flows';
// import useFetchQuery from '../../../../../lib/graphql/useFetchQuery';
import { faSearch ,faInfoCircle} from '@fortawesome/free-solid-svg-icons';
const { getConfig } = require('../../../../../../lib/intl/followupc');
//SA975
require('dotenv').config();
const FOLLOW_API= getConfig("REACT_APP_FOLLOW_API");
//EA975
export default function AdditionalDetails({
  goToStep,
  proceedToNextStep,
  setProceedToNextStep,
  setParentAlerts,
  setCustomLoadingMessage,
  setLoadingStep,
  productCode,
  productName,
  lobCode,
  lobName,
  productType,
  ...props
}) {
  const fetchQuery = useFetchQuery();
  const mutateQuery = useMutationQuery();
  const { branding } = useContext(QuantaConfigContext);
  const repeatForDesktop = 3,
    repeatForMobile = 2;
  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });
  const changeInputType = useResponsiveParams({
    for_mobile: 'input-lookup',
    for_desktop: 'text',
  });
  const colSpanParams = useResponsiveParams({
    for_mobile: { searchString: 8, button: 2 },
    for_desktop: { searchString: 4, button: 1 },
  });
  const screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
  });
  const modalSizeExternal = useResponsiveParams({
    for_desktop: 'large',
    for_mobile: 'small',
    for_iPad: 'large',
  });
  const icon_idle = (
    <img
      src={branding.illustration.no_data}
      alt="no data"
      className="lg:w-80 lg:h-80 w-64 h-64 opacity-50"
    />
  );
  const initLoadRef = useRef([]);

  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toLowerCase() ===
        searchText?.toLowerCase(),
    )
      ? domainArr.find(
          (d) =>
            d[`${searchType}`]?.toLowerCase() ===
            searchText?.toLowerCase(),
        )[`${returnType}`]
      : '';
  };
  const MINOR_THRESHOLD_AGE = 18;
  const {
    loading,
    error,
    data: dataBuyMotorPolicy,
    previousData,
  } = useQuery(GET_BUY_MOTOR_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
    skip: new Set(initLoadRef.current).size >= 3,
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 1];
    },
  });
  let prdcode = "2880";
  const { loading: loadingdrop, data: dropDownDetails } = useQuery(
    PROPOSER_DROPDOWN_DETAIL,
    {
      fetchPolicy: 'cache-first',
      variables: {
        productCode: prdcode,
      },
    },
  );
  const {
    loading: loadingFinancerDropDownDetails,
    error: errorFinancerDropdownDetails,
    data: dataFinancerDropdownDetails,
  } = useQuery(FINANCER_DROPDOWN_DETAILS, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode,
    },
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 2];
    },
  });
  let startDate_min = undefined;

  // const {
  //   loading: loadingUploadDocsVar,
  //   error: errorUploadDocsVar,
  //   data: dataUploadDocsVar,
  // } = useQuery(GET_BUY_FIRE_UPLOAD_POLICY_VAR_DETAILS, {
  //   fetchPolicy: 'cache-first',
  // });

  const {
    loading: loadingPreviousInsurerDetails,
    error: errorPreviousInsurerDetails,
    data: dataPreviousInsurerDetails,
  } = useQuery(PREVIOUS_INSURER_COMPANY_LIST, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode,
    },
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 3];
    },
  });



 

  const {
    loading: loadingDocumentExtensions,
    error: errorDocumentExtensions,
    data: dataDocumentExtensions,
  } = useQuery(DOCUMENT_STATIC_DATA, {
    fetchPolicy: 'cache-first',
  });



  if (
    loading ||
    loadingFinancerDropDownDetails ||
    loadingPreviousInsurerDetails ||
    loadingdrop
    // ||
    // loadingUploadDocsVar
  ) {
    return (
      <div className="min-h-screen">
        <Loading />
      </div>
    );
  }
  if (loadingDocumentExtensions) {
    return <Loading />;
  }

  if (
    error ||
    errorFinancerDropdownDetails ||
    errorPreviousInsurerDetails
  ) {
    return (
      <div className="min-h-screen">
        <Error
          error={
            error ||
            errorFinancerDropdownDetails ||
            errorPreviousInsurerDetails
          }
        />
      </div>
    );
  }
   
  if (errorDocumentExtensions) {
    return <Error error={errorDocumentExtensions} />;
  }


  const { buyMotorPolicy } = dataBuyMotorPolicy
    ? dataBuyMotorPolicy
    : previousData;
  const { quoteData, intermediaryDetails } = buyMotorPolicy;
  const { PRD_FinancerAgreementType, PRD_IsYourVehicle } =
    dataFinancerDropdownDetails;
  const { rolloverCompanyList } = dataPreviousInsurerDetails;
  const { PRD_NomiRelationWithMemb, PRD_ApointRelationWithMinNomi } =
    dropDownDetails;
    const {
      documentListCarSecure,
      documentExtensions,
      docFileSizeLimit,
      docDescCharacterLimit,
    } = dataDocumentExtensions;
    
  let b = 'Owner Driver';
  const initialValues = {
    previousInsuranceAndClaims: {
      previousPolicyDetails: {
        TPpreviousInsurerName: buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousPolicyDetails
          ?.TPpreviousInsurerName
          ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.TPpreviousInsurerName}`
          : quoteData?.prevInsurance?.insurerName
          ? `${quoteData?.prevInsurance?.insurerName}`
          : rolloverCompanyList && rolloverCompanyList?.length > 0
          ? rolloverCompanyList?.code
          : '',
        TPexpiringPolicyNumber: buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousPolicyDetails
          ?.TPexpiringPolicyNumber
          ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.TPexpiringPolicyNumber}`
          : quoteData?.prevInsurance?.policyNumber
          ? `${quoteData?.prevInsurance?.policyNumber}`
          : '',
        previousInsurerName: buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousPolicyDetails
          ?.previousInsurerName
          ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.previousInsurerName}`
          : quoteData?.prevInsurance?.insurerName
          ? `${quoteData?.prevInsurance?.insurerName}`
          : rolloverCompanyList && rolloverCompanyList?.length > 0
          ? rolloverCompanyList?.code
          : '',
        expiringPolicyNumber: buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousPolicyDetails
          ?.expiringPolicyNumber
          ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.expiringPolicyNumber}`
          : quoteData?.prevInsurance?.policyNumber
          ? `${quoteData?.prevInsurance?.policyNumber}`
          : '',
        policyCoverType: buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousPolicyDetails
          ?.policyCoverType
          ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyCoverType}`
          : quoteData?.policyCoverType
          ? `${quoteData?.policyCoverType}`
          : '',
        policyStartDate: buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousPolicyDetails
          ?.policyStartDate
          ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyStartDate}`
          : quoteData?.policyStartDate
          ? `${quoteData?.policyStartDate}`
          : '',
        policyExpiryDate: buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousPolicyDetails
          ?.policyExpiryDate
          ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyExpiryDate}`
          : quoteData?.policyExpiryDate
          ? `${quoteData?.policyExpiryDate}`
          : '',
        policyTenure: buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousPolicyDetails
          ?.policyTenure
          ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenure}`
          : quoteData?.policyTenure
          ? `${quoteData?.policyTenure}`
          : '',
        policyTenureValue: buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousPolicyDetails
          ?.policyTenureValue
          ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue}`
          : quoteData?.policyTenureValue
          ? `${quoteData?.policyTenureValue}`
          : '',
      },
      previousClaims: {
        totalClaimCount: buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousClaims
          ?.totalClaimCount
          ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.totalClaimCount}`
          : quoteData?.totalClaimCount
          ? `${quoteData?.totalClaimCount}`
          : '',
        totalClaimCountValue: buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousClaims
          ?.totalClaimCountValue
          ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.totalClaimCountValue}`
          : quoteData?.totalClaimCountValue
          ? `${quoteData?.totalClaimCountValue}`
          : '',
        totalClaimAmount: buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousClaims
          ?.totalClaimAmount
          ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.totalClaimAmount}`
          : quoteData?.totalClaimAmount
          ? `${quoteData?.totalClaimAmount}`
          : '',
        previousYearNCBSlab: buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousClaims
          ?.previousYearNCBSlab
          ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.previousYearNCBSlab}`
          : quoteData?.previousYearNCBSlab
          ? `${quoteData?.previousYearNCBSlab}`
          : '',
        noOfClaimsYear1: buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousClaims
          ?.noOfClaimsYear1
          ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear1}`
          : quoteData?.noOfClaimsOneYear
          ? `${quoteData?.noOfClaimsOneYear}`
          : '',
        noOfClaimsYear2: buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousClaims
          ?.noOfClaimsYear2
          ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear2}`
          : quoteData?.noOfClaimsTwoYears
          ? `${quoteData?.noOfClaimsTwoYears}`
          : '',
        noOfClaimsYear3: buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousClaims
          ?.noOfClaimsYear3
          ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear3}`
          : quoteData?.noOfClaimsThreeYears
          ? `${quoteData?.noOfClaimsThreeYears}`
          : '',
      },
    },
    nomineeDetails: {
      nomineeName: buyMotorPolicy?.additionalTabDetails
        ?.nomineeDetails?.nomineeName
        ? `${buyMotorPolicy?.additionalTabDetails?.nomineeDetails?.nomineeName}`
        : '',
      nomineeDob: buyMotorPolicy?.additionalTabDetails?.nomineeDetails
        ?.nomineeDob
        ? `${buyMotorPolicy?.additionalTabDetails?.nomineeDetails?.nomineeDob}`
        : '',
      relationshipWithNominee: buyMotorPolicy?.additionalTabDetails
        ?.nomineeDetails?.relationshipWithNominee
        ? `${buyMotorPolicy?.additionalTabDetails?.nomineeDetails?.relationshipWithNominee}`
        : '',
      nameOfAppointee: buyMotorPolicy?.additionalTabDetails
        ?.nomineeDetails?.nameOfAppointee
        ? `${buyMotorPolicy?.additionalTabDetails?.nomineeDetails?.nameOfAppointee}`
        : '',
      relationshipWithAppointee: buyMotorPolicy?.additionalTabDetails
        ?.nomineeDetails?.relationshipWithAppointee
        ? `${buyMotorPolicy?.additionalTabDetails?.nomineeDetails?.relationshipWithAppointee}`
        : '',
    },
    financeDetails: {
      vehicleOwned: buyMotorPolicy?.additionalTabDetails
        ?.financeDetails?.vehicleOwned
        ? `${buyMotorPolicy?.additionalTabDetails?.financeDetails?.vehicleOwned}`
        : buyMotorPolicy?.quoteData?.financerName
        ? getDomainData(
            PRD_IsYourVehicle,
            'financed',
            'value',
            'code',
          )
        : PRD_IsYourVehicle && PRD_IsYourVehicle?.length > 0
        ? PRD_IsYourVehicle[0]?.code
        : '',
      financerDetails: {
        financerName: buyMotorPolicy?.additionalTabDetails
          ?.financeDetails?.financerDetails?.financerName
          ? `${buyMotorPolicy?.additionalTabDetails?.financeDetails?.financerDetails?.financerName}`
          : quoteData?.financerName
          ? `${quoteData?.financerName}`
          : '',
        financerAddress: buyMotorPolicy?.additionalTabDetails
          ?.financeDetails?.financerDetails?.financerAddress
          ? `${buyMotorPolicy?.additionalTabDetails?.financeDetails?.financerDetails?.financerAddress}`
          : '',
        financerAgreementType: buyMotorPolicy?.additionalTabDetails
          ?.financeDetails?.financerDetails?.financerAgreementType
          ? `${buyMotorPolicy?.additionalTabDetails?.financeDetails?.financerDetails?.financerAgreementType}`
          : PRD_FinancerAgreementType && PRD_FinancerAgreementType.length >0
          ?PRD_FinancerAgreementType[0]?.code
          : '',
        loanAccountNumber: buyMotorPolicy?.additionalTabDetails
          ?.financeDetails?.financerDetails?.loanAccountNumber
          ? `${buyMotorPolicy?.additionalTabDetails?.financeDetails?.financerDetails?.loanAccountNumber}`
          : '',
        fileNumber: buyMotorPolicy?.additionalTabDetails
          ?.financeDetails?.financerDetails?.fileNumber
          ? `${buyMotorPolicy?.additionalTabDetails?.financeDetails?.financerDetails?.fileNumber}`
          : '',
      },
    },
    // trailerDetails:[
    //   buyMotorPolicy?.quoteData?.trailerDetails?.forEach((_, idx) => {
    //     trailerArr.push({
    //         make:buyMotorPolicy?.quoteData?.trailerDetails[idx].make,
    //         model: buyMotorPolicy?.quoteData?.trailerDetails[idx].model,
    //         regnumber:buyMotorPolicy?.quoteData?.trailerDetails[idx].regnumber,
    //         ChassisNumber: buyMotorPolicy?.quoteData?.trailerDetails[idx].ChassisNumber,
    //         SI: buyMotorPolicy?.quoteData?.trailerDetails[idx].SI,
    //         yearofmanufacture: buyMotorPolicy?.quoteData?.trailerDetails[idx].yearofmanufacture,
    //       });
    //     })
    // ],
     documentDetails:
      // documentDetailsVar && documentDetailsVar?.length > 0
      //   ? documentDetailsVar
      //   :
         [
            {
              documentDescription: '',
              documentName: '',
              documentNameValue: '',
              documentFileName: '',
              documentFileNameWithExtension: '',
              documentExtension: '',
              documentSize: null,
              documentSizeinKB: '',
              dragging: false,
              dragCounter: 0,
              documentBase64String: '',
            },
          ],
    // documentDetails:
    // buyMotorPolicy?.additionalTabDetails?.documentDetails
    //   ?.length === 0
    //   ? [
    //       {
    //         documentDescription: '',
    //         documentName: '',
    //         documentNameValue: '',
    //         documentFileName: '',
    //         documentFileNameWithExtension: '',
    //         documentExtension: '',
    //         documentSize: null,
    //         documentSizeinKB: '',
    //         dragging: false,
    //         dragCounter: 0,
    //         documentBase64String: '',
    //       },
    //     ]
    //   : buyMotorPolicy?.additionalTabDetails?.documentDetails?.map(
    //       (documentDetails) => {
    //         return {
    //           ...documentDetails,
    //         };
    //       },
    //     ),
  };

  const validate = (values) => {
    let errors = {};
    errors.nomineeDetails = {};
    errors.financeDetails = {};
    errors.financeDetails.financerDetails = {};
    errors.previousInsuranceAndClaims = {};
    errors.previousInsuranceAndClaims.previousPolicyDetails = {};
    errors.documentDetails = values?.documentDetails?.map((_) => {
      return {};
    }); 
    let errorCount = 0;


    if ((quoteData?.businessType?.toLowerCase() === 'roll over' || quoteData?.businessType?.toLowerCase() === 'new business') &&
      quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'
        // || quoteData?.businessType?.toLowerCase() === 'used car' 
    ) {
      if (
        !values?.previousInsuranceAndClaims?.previousPolicyDetails
          .previousInsurerName
      ) {
        errors.previousInsuranceAndClaims.previousPolicyDetails.previousInsurerName =
          '* Required';
      }
      if (
        values?.previousInsuranceAndClaims?.previousPolicyDetails
          .previousInsurerName &&
        !getDomainData(
          rolloverCompanyList,
          values?.previousInsuranceAndClaims?.previousPolicyDetails
            .previousInsurerName,
          'code',
          'value',
        )
      ) {
        errors.previousInsuranceAndClaims.previousPolicyDetails.previousInsurerName =
          '* Invalid Insurer';
      }
      // if (
      //   values?.previousInsuranceAndClaims?.previousPolicyDetails.previousInsurerName.match(
      //     /\d/,
      //   )
      // ) {
      //   errors.previousInsuranceAndClaims.previousPolicyDetails.previousInsurerName =
      //     '* Insurer name cannot be alphanumeric';
      // }
      if (
        !values?.previousInsuranceAndClaims?.previousPolicyDetails
          .expiringPolicyNumber
      ) {
        errors.previousInsuranceAndClaims.previousPolicyDetails.expiringPolicyNumber =
          '* Required';
      }
      // if (
      //   values?.previousInsuranceAndClaims?.previousPolicyDetails
      //     ?.expiringPolicyNumber &&
      //   !values?.previousInsuranceAndClaims?.previousPolicyDetails?.expiringPolicyNumber?.match(
      //     /^[a-zA-Z0-9]+$/,
      //   )  //removed this validation to allow Expiring Policy Number from Zoop 
      // ) {
      //   errors.previousInsuranceAndClaims.previousPolicyDetails.expiringPolicyNumber =
      //     '* Policy Number can be alphanumeric only';
      // }
    }
    if (
      values?.financeDetails?.vehicleOwned?.toLowerCase() ===
      'financed'
    ) {
      // if (!values?.financeDetails?.financerDetails?.financerName) {
      //   errors.financeDetails.financerDetails.financerName =
      //     '* Required';
      // }
      // if (!values?.financeDetails?.financerDetails?.financerAddress) {
      //   errors.financeDetails.financerDetails.financerAddress =
      //     '* Required';
      // }
      // if (
      //   values?.financeDetails?.financerDetails?.financerName &&
      //   !values?.financeDetails?.financerDetails?.financerName.match(
      //     /^[a-zA-Z0-9]*$/, //^[a-zA-Z ]*$/,
      //   )
      // ) {
      //   errors.financeDetails.financerDetails.financerName =
      //     '* Policy Number can be alphanumeric only'; //Name can only contain alphabets';
      // }
      // if (
      //   !values?.financeDetails?.financerDetails
      //     ?.financerAgreementType
      // ) {
      //   errors.financeDetails.financerDetails.financerAgreementType =
      //     '* Required';
      // }
      // if (!values?.financeDetails?.financerDetails?.fileNumber) {
      //   errors.financeDetails.financerDetails.fileNumber =
      //     '* Required';
      // }
      // if (
      //   !values?.financeDetails?.financerDetails?.loanAccountNumber
      // ) {
      //   errors.financeDetails.financerDetails.loanAccountNumber =
      //     '* Required';
      // }
    }
   if (buyMotorPolicy?.coverData?.addOnCovers?.[b]?.selected?.toString() === 'true') {
    // if(getDomainData(customerTypeList,buyMotorPolicy?.proposerDetails?.customerType,'code','value')?.toLowerCase() === 'individual') {
      if (!values?.nomineeDetails?.nomineeName) {
        errors.nomineeDetails.nomineeName = '* Required';
      }
      if (
        values?.nomineeDetails?.nomineeName &&
        values?.nomineeDetails?.nomineeName.match(/\d/)
      ) {
        errors.nomineeDetails.nomineeName =
          '* Name cannot be alphanumeric';
      }
      if (!values?.nomineeDetails?.nomineeDob) {
        errors.nomineeDetails.nomineeDob = '* Required';
      }
      if (values?.nomineeDetails?.nomineeDob) {
        if (
          moment(
            values?.nomineeDetails?.nomineeDob,
            'DD/MM/YYYY',
          ).isAfter()
        ) {
          errors.nomineeDetails.nomineeDob =
            '* Date of Birth cannot be a future date';
        }
      }
      if (!values?.nomineeDetails?.relationshipWithNominee) {
        errors.nomineeDetails.relationshipWithNominee = '* Required';
      }
      if (
        values?.nomineeDetails?.nomineeDob &&
        moment(new Date(), 'DD/MM/YYYY').diff(
          moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
          'years',
        ) < MINOR_THRESHOLD_AGE
      ) {
        if (!values?.nomineeDetails?.nameOfAppointee) {
          errors.nomineeDetails.nameOfAppointee = '* Required';
        }
        if (
          values?.nomineeDetails?.nameOfAppointee &&
          values?.nomineeDetails?.nameOfAppointee.match(/\d/)
        ) {
          errors.nomineeDetails.nameOfAppointee =
            '* Name cannot be alphanumeric';
        }
        if (!values?.nomineeDetails?.relationshipWithAppointee) {
          errors.nomineeDetails.relationshipWithAppointee =
            '* Required';
        }
      }
    //   }
    }
    if (
      Object.keys(errors.nomineeDetails).length === 0 &&
      Object.keys(
        errors.previousInsuranceAndClaims.previousPolicyDetails,
      ).length === 0 &&
      Object.keys(errors.financeDetails.financerDetails).length === 0
    ) {
      errors = {};
    }
    return errors;
  };

  const AdditionalDetailform = ({ validate }) => {
    const { values,setFieldValue } = useQuantaFormikContext();
    const [financierNameModalDisplay, showFinancierNameModal] =
      useState(false);
    const [financierNameOutput, setFinancierNameOutput] = useState(
      [],
    );
    const uploadDocRef = useRef([]);
  

  // const clickEnabled = !loadingDocumentExtensions;

    const [errors, setErrors] = useState({ financierNameList: '' });
    const [onDataUpdate, setOnUpdate] = useState(null);
    const [loadingFinancierName, setLoadingFinancierName] =
      useState(false);
    const [searchStringFinancierName, setSearchStringFinancierName] =
      useState('');
    const reformData = (val, returnType) => {
      return val && val.toString().trim() !== '' ? val : returnType;
    };
    const onFinancierNameSearch = async (val, _) => {
      if (val.length > 0) {
        try {
          setFinancierNameOutput([]);
          let queryOutput = fetchQuery({
            fetchPolicy: 'network-only',
            query: FINANCER_DROPDOWN_DETAILS_GCV,
            variables: {
              input: {
                bankName: val,
              },
            },
          });
          setLoadingFinancierName(true);
          let { data } = await queryOutput;
          setLoadingFinancierName(false);
          // setFinancierNameOutput(data.getFinancierNameList);
          setFinancierNameOutput(data.gcvFinancierSearch.financier);
        } catch (error) {
          setErrors({
            ...errors,
            financierNameList: error?.message,
          });
          setLoadingFinancierName(false);
          setFinancierNameOutput([]);
        }
      }
    };
    const searchInput = {
      flow: 'cols',
      repeat: 5,
      data:
        changeInputType === 'text'
          ? [
              {
                type: 'text',
                name: 'searchString',
                size: 'full',
                colSpan: colSpanParams.searchString,
              },
              {
                type: 'submit',
                size: 'full',
                colSpan: colSpanParams.button,
                iconPre: <FontAwesomeIcon icon={faSearch} />,
                children: 'Search',
              },
            ]
          : [
              {
                type: 'input-lookup',
                name: 'searchString',
                size: 'full',
                colSpan: colSpanParams.searchString,
                onLookup: onFinancierNameSearch,
              },
            ],
      initialValues: {
        searchString: searchStringFinancierName,
      },
      validate: (values) => {
        const errors = {};
        if (!values.searchString) errors.searchString = '* Required';
        return errors;
      },
      onSearch: async (values) => {
        try {
          setFinancierNameOutput([]);
          let queryOutput = fetchQuery({
            fetchPolicy: 'network-only',
            query: FINANCER_DROPDOWN_DETAILS_GCV,
            variables: {
              input: {
                bankName: values.searchString
                //  , value: values.searchString,
              },
            },
          });
          setLoadingFinancierName(true);
          let { data } = await queryOutput;
          setLoadingFinancierName(false);
          // setFinancierNameOutput(data.getFinancierNameList);
          setFinancierNameOutput(data.gcvFinancierSearch
            .financier);
        } catch (error) {
          setErrors({
            ...errors,
            financierNameList: error?.message,
          });
          setLoadingFinancierName(false);
          setFinancierNameOutput([]);
        }
      },
    };
    const searchResults = {
      data: financierNameOutput,
      onIdle: () => {
        if (loadingFinancierName) {
          return <Loading />;
        } else if (searchStringFinancierName === '') {
          return icon_idle;
        }
        return undefined;
      },
      columns: [
        {
          Header: 'Financer Name',
          accessor: 'bankName',
        },
      ],
      list: financierNameOutput.map((data) => {
        return {
          // title: `${data.value}`,
          title: `${data.bankName}`,
          onClick: () => {
            onDataUpdate(data);
            
            showFinancierNameModal(false);
            document.body.classList.remove('overflow-y-hidden');
          },
        };
      }),
      // sortBy: { id: 'value', desc: false },
      sortBy: { id: 'bankName', desc: false },
    };
    const onClose = () => {
      showFinancierNameModal(false);
    };
    const onNoResultsFound = () => {
      return errors.financierNameList;
    };
    const onMessage = () => {};
    const paginationInput = {
      offset: 0,
      PAGE_SIZE: 4,
    };
    const data = [
      (quoteData?.businessType?.toLowerCase() === 'roll over' ||
       quoteData?.businessType?.toLowerCase() === 'new business') &&
      quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'
        //||quoteData?.businessType?.toLowerCase() === 'used car'
        ? {
            title: (
              <Text severity="info" type="title">
                Previous Insurance & Claims Details
              </Text>
            ),
            grid_type: 'data',
            grid_data: [
              {
                text: (
                  <Text
                    type="large"
                    severity="info"
                    className="font-semibold"
                  >
                    Previous Policy
                  </Text>
                ),
                colSpan: repeat,
              },
              {
                label: (
                  <>
                    Previous Insurer Name{' '}
                    <Text severity={'error'}>*</Text>
                  </>
                ),
                colSpan: repeat === repeatForMobile ? repeat : 1,
                text: (
                  <div className={'mt-1'}>
                    <QuantaSelect
                      name={
                        'previousInsuranceAndClaims.previousPolicyDetails.previousInsurerName'
                      }
                      disabled={
                        buyMotorPolicy?.proposalNumber?.length > 0
                        && !buyMotorPolicy?.isProposalModify
                      }
                      data={
                        rolloverCompanyList &&
                        rolloverCompanyList?.length > 0
                          ? rolloverCompanyList?.map((company) => {
                              return {
                                label: company?.value
                                  ? `${company?.value}`
                                  : '',
                                value: company?.code
                                  ? `${company?.code}`
                                  : '',
                              };
                            })
                          : []
                      }
                      searchable={true}
                      size={'full'}
                    />
                  </div>
                ),
              },
              {
                label: (
                  <>
                    Expiring Policy Number{' '}
                    <Text severity={'error'}>*</Text>
                  </>
                ),
                colSpan: repeat === repeatForMobile ? repeat : 1,
                text: (
                  <div className={'mt-1'}>
                    <QuantaInput
                      name={
                        'previousInsuranceAndClaims.previousPolicyDetails.expiringPolicyNumber'
                      }
                      disabled={
                        buyMotorPolicy?.proposalNumber?.length > 0
                        && !buyMotorPolicy?.isProposalModify
                      }
                      size={'full'}
                    />
                  </div>
                ),
              },
              {
                label: 'Policy/Cover Type',
                text: values?.previousInsuranceAndClaims
                  ?.previousPolicyDetails?.policyCoverType,
              },
              {
                label: 'Policy Start Date',
                text: values?.previousInsuranceAndClaims
                  ?.previousPolicyDetails?.policyStartDate,
              },
              {
                label: 'Policy Expiry Date',
                text: values?.previousInsuranceAndClaims
                  ?.previousPolicyDetails?.policyExpiryDate,
              },
              // productCode.toString() != '3121'||productCode.toString() != '3151' ||productCode.toString() != '3176' ?
              // {
              //   label: 'Policy Tenure',
              //   text: values?.previousInsuranceAndClaims
              //     ?.previousPolicyDetails?.policyTenure,
              // }:null,
              {
                text: (
                  <Text
                    severity="info"
                    type="large"
                    className="font-semibold"
                  >
                    Previous Claims
                  </Text>
                ),
                colSpan: repeat,
                className: 'mt-3',
              },
              // values?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue
              //   ?.toLowerCase()
              //   ?.search('annual') !== -1
              //   ?
                 {
                    label: 'Total Claim Count',
                    text: values?.previousInsuranceAndClaims
                      ?.previousClaims?.totalClaimCount,
                  },
              //  : null,
              // (values?.previousInsuranceAndClaims?.previousClaims
              //   ?.totalClaimAmount && productCode?.toString()!=="3152")
              // ? {
              //   label: 'Total Claim Amount',
              //   text: CurrencyFormater(
              //     values?.previousInsuranceAndClaims?.previousClaims
              //       ?.totalClaimAmount,
              //     true,
              //     false,
              //     branding,
              //   ),
              // } : null,
                
              // values?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue
              //   ?.toLowerCase()
              //   ?.search('long term') !== -1
              //   ? {
              //       label: 'No of Claims in Year 1',
              //       text: values?.previousInsuranceAndClaims
              //         ?.previousClaims?.noOfClaimsYear1,
              //     }
              //   : null,
              // values?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue
              //   ?.toLowerCase()
              //   ?.search('long term') !== -1
              //   ? {
              //       label: 'No of Claims in Year 2',
              //       text: values?.previousInsuranceAndClaims
              //         ?.previousClaims?.noOfClaimsYear2,
              //     }
              //   : null,
              // values?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue
              //   ?.toLowerCase()
              //   ?.search('long term') !== -1
              //   ? {
              //       label: 'No of Claims in Year 3',
              //       text: values?.previousInsuranceAndClaims
              //         ?.previousClaims?.noOfClaimsYear3,
              //     }
              //   : null,
              (values?.previousInsuranceAndClaims?.previousClaims
                ?.totalClaimAmount && productCode?.toString()!=="3152")
              ? {
                label: 'Total Claim Amount',
                text: CurrencyFormater(
                  values?.previousInsuranceAndClaims?.previousClaims
                    ?.totalClaimAmount,
                  true,
                  false,
                  branding,
                ),
              } : null,
              (values?.previousInsuranceAndClaims?.previousClaims
                ?.previousYearNCBSlab && productCode?.toString()!=="3192")
                ? {
                    label: 'Previous Year NCB Slab',
                    text: `${values?.previousInsuranceAndClaims?.previousClaims?.previousYearNCBSlab} %`,
                  }
                : null,
               quoteData?.productCode?.toString()=='3151'
              //  && 
              //  quoteData?.policyCoverType!=='OD Only'
                ?
                {
                  text: (
                    <Text
                      severity="info"
                      type="large"
                      className="font-semibold"
                    >
                      TP Policy Details
                    </Text>
                  ),
                  colSpan: repeat,
                  className: 'mt-3',
                }:'',
               quoteData?. productCode?.toString()=='3151'
              //  && quoteData?.policyCoverType!=='OD Only'
                ?
                {
                  label: (
                    <>
                      TP Previous Insurer Name{' '}
                      <Text severity={'error'}>*</Text>
                    </>
                  ),
                  colSpan: repeat === repeatForMobile ? repeat : 1,
                  text: (
                    <div className={'mt-1'}>
                      <QuantaSelect
                        name={
                          'previousInsuranceAndClaims.previousPolicyDetails.TPpreviousInsurerName'
                        }
                        disabled={
                          buyMotorPolicy?.proposalNumber?.length > 0
                          && !buyMotorPolicy?.isProposalModify
                        }
                        data={
                          rolloverCompanyList &&
                          rolloverCompanyList?.length > 0
                            ? rolloverCompanyList?.map((company) => {
                                return {
                                  label: company?.value
                                    ? `${company?.value}`
                                    : '',
                                  value: company?.code
                                    ? `${company?.code}`
                                    : '',
                                };
                              })
                            : []
                        }
                        searchable={true}
                        size={'full'}
                      />
                    </div>
                  ),
                } :'',
              quoteData?.  productCode?.toString()=='3151' 
              // && quoteData?.policyCoverType!=='OD Only'
                ?
                {
                  label: (
                    <>
                      TP Expiring Policy Number{' '}
                      <Text severity={'error'}>*</Text>
                    </>
                  ),
                  colSpan: repeat === repeatForMobile ? repeat : 1,
                  text: (
                    <div className={'mt-1'}>
                      <QuantaInput
                        name={
                          'previousInsuranceAndClaims.previousPolicyDetails.TPexpiringPolicyNumber'
                        }
                        disabled={
                          buyMotorPolicy?.proposalNumber?.length > 0
                          && !buyMotorPolicy?.isProposalModify
                        }
                        size={'full'}
                      />
                    </div>
                  ),
                } :'',
               quoteData?. productCode?.toString()=='3151'
              //  && quoteData?.policyCoverType!=='OD Only'
                ?
                {
                  label: 'TP Policy Start Date',
                  text: quoteData?.TP_Start_Date,
                }:'',
                quoteData?. productCode?.toString()=='3151'
                // && quoteData?.policyCoverType!=='OD Only'
                ?
                {
                  label: 'TP Policy Expiry Date',
                  text: quoteData?.TP_End_Date,
                } :'',
                // productCode?.toString()=='3152'
                // ?
                // {
                //   label: 'TP Policy Tenure',
                //   text: quoteData?.TP_Policy_Tenure,
                // } :'',
            ].filter((d) => d),
          }
        : null,
      buyMotorPolicy?.coverData?.addOnCovers?.[b]?.selected === true ?
        {
          title: 'Nominee Details',
          grid_data: [
            {
              type: 'text',
              disabled: buyMotorPolicy?.proposalNumber?.length > 0   && !buyMotorPolicy?.isProposalModify
,
              colSpan: repeat === repeatForMobile ? repeat : 1,
              label: (
                <>
                  Nominee Name{' '}
                  <Text severity={'error'}>*</Text>
                </>
              ),
              name: 'nomineeDetails.nomineeName',
            },
            {
              type: 'date',
              disabled: buyMotorPolicy?.proposalNumber?.length > 0
              && !buyMotorPolicy?.isProposalModify,
              colSpan: repeat === repeatForMobile ? repeat : 1,
              label: (
                <>
                  Nominee Date of Birth{' '}
                  <Text severity={'error'}>*</Text>
                </>
              ),
              name: 'nomineeDetails.nomineeDob',
              onDataChange: (val, setFieldValue) => {
                if (
                  moment(new Date(), 'DD/MM/YYYY').diff(
                    moment(val, 'DD/MM/YYYY'),
                    'years',
                  ) >= MINOR_THRESHOLD_AGE
                ) {
                  setFieldValue(
                    `nomineeDetails.nameOfAppointee`,
                    '',
                  );
                  setFieldValue(
                    `nomineeDetails.relationshipWithAppointee`,
                    '',
                  );
                }
              }
            },
            {
              type: 'select',
              size: 'large',
              disabled: buyMotorPolicy?.proposalNumber?.length > 0
              && !buyMotorPolicy?.isProposalModify,
              colSpan: repeat === repeatForMobile ? repeat : 1,
              label:
                (
                  <>
                    Relationship{' '}
                    <Text severity={'error'}>*</Text>
                  </>
                ),
              name: 'nomineeDetails.relationshipWithNominee',
              data: (PRD_NomiRelationWithMemb && PRD_NomiRelationWithMemb?.length > 0) ? PRD_NomiRelationWithMemb?.map((relationship) => {
                return {
                  label: relationship?.value ? relationship?.value : '',
                  value: relationship?.code ? relationship?.code : ''
                }
              }) : [],
            },
            {
              type: 'text',
              disabled: buyMotorPolicy?.proposalNumber?.length > 0  && !buyMotorPolicy?.isProposalModify,
              colSpan: repeat === repeatForMobile ? repeat : 1,
              label: (
                <>
                  Name of Appointee <Text severity="error"> {`${
                    // (getDomainData(customerTypeList,buyMotorPolicy?.proposerDetails?.customerType,'code','value')?.toLowerCase() === 'individual' && 
                    (moment(new Date(), 'DD/MM/YYYY').diff(
                      moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
                      'years',
                    ) < MINOR_THRESHOLD_AGE) ? '*' : ''}`}</Text>
                </>
              ),
              name: 'nomineeDetails.nameOfAppointee',
              disabled: (moment(new Date(), 'DD/MM/YYYY').diff(
                moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
                'years',
              ) >= MINOR_THRESHOLD_AGE || buyMotorPolicy?.proposalNumber?.length > 0
              && !buyMotorPolicy?.isProposalModify)
            },
            {
              type: 'select',
              size: 'large',
              colSpan: repeat === repeatForMobile ? repeat : 1,
              label: (
                <>
                  Relationship with Appointee{' '}
                  <Text severity="error"> {`${
                    // (getDomainData(customerTypeList,buyMotorPolicy?.proposerDetails?.customerType,'code','value')?.toLowerCase() === 'individual'
                    (moment(new Date(), 'DD/MM/YYYY').diff(
                      moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
                      'years',
                    ) < MINOR_THRESHOLD_AGE) ? '*' : ''}`}</Text>
                </>
              ),
              name: 'nomineeDetails.relationshipWithAppointee',
              disabled: (moment(new Date(), 'DD/MM/YYYY').diff(
                moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
                'years',
              ) >= MINOR_THRESHOLD_AGE || ( buyMotorPolicy?.proposalNumber?.length > 0
                && !buyMotorPolicy?.isProposalModify )
),
              data: (PRD_ApointRelationWithMinNomi && PRD_ApointRelationWithMinNomi?.length > 0) ? PRD_ApointRelationWithMinNomi?.map((relationship) => {
                return {
                  label: relationship?.value ? relationship?.value : '',
                  value: relationship?.code ? relationship?.code : ''
                }
              }) : [],
            },
          ]
        } : '',
        //  {
        //   title: 'Preinspection  Details',
        //   grid_data: [
           
           
        //     {
        //       type: 'select',
        //       size: 'large',
        //       disabled: buyMotorPolicy?.proposalNumber?.length > 0,
        //       colSpan: repeat === repeatForMobile ? repeat : 1,
        //       label:
        //         (
        //           <>
        //             Preinspection Agency Name{' '}
        //             <Text severity={'error'}>*</Text>
        //           </>
        //         ),
        //       name: 'preinspectionDetails.preinspectionAgencyName',
        //       data: (PRD_NomiRelationWithMemb && PRD_NomiRelationWithMemb?.length > 0) ? PRD_NomiRelationWithMemb?.map((relationship) => {
        //         return {
        //           label: relationship?.value ? relationship?.value : '',
        //           value: relationship?.code ? relationship?.code : ''
        //         }
        //       }) : [],
        //     },
        //     {
        //       type: 'text',
        //       disabled: buyMotorPolicy?.proposalNumber?.length > 0,
        //       colSpan: repeat === repeatForMobile ? repeat : 1,
        //       label: (
        //         <>
        //           Pre-Inspection Number{' '}
        //           <Text severity={'error'}>*</Text>
        //         </>
        //       ),
        //       name: 'preinspectionDetails.preInspectionNumber',
        //     },
        //     {
        //       type: 'date',
        //       disabled: buyMotorPolicy?.proposalNumber?.length > 0,
        //       colSpan: repeat === repeatForMobile ? repeat : 1,
        //       label: (
        //         <>
        //           Preinspection Date & time{' '}
        //           <Text severity={'error'}>*</Text>
        //         </>
        //       ),
        //       name: 'preinspectionDetails.preinspectionDatetime',
        //       // onDataChange: (val, setFieldValue) => {
        //       //   if (
        //       //     moment(new Date(), 'DD/MM/YYYY').diff(
        //       //       moment(val, 'DD/MM/YYYY'),
        //       //       'years',
        //       //     ) >= MINOR_THRESHOLD_AGE
        //       //   ) {
        //       //     setFieldValue(
        //       //       `nomineeDetails.nameOfAppointee`,
        //       //       '',
        //       //     );
        //       //     setFieldValue(
        //       //       `nomineeDetails.relationshipWithAppointee`,
        //       //       '',
        //       //     );
        //       //   }
        //       // }
        //     },
        //     {
        //       type: 'text',
        //       disabled: buyMotorPolicy?.proposalNumber?.length > 0,
        //       colSpan: repeat === repeatForMobile ? repeat : 1,
        //       label: (
        //         <>
        //           Status - recommended <Text severity="error"></Text>
        //         </>
        //       ),
        //       name: 'preinspectionDetails.status',
        //       // disabled: (moment(new Date(), 'DD/MM/YYYY').diff(
        //       //   moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
        //       //   'years',
        //       // ) >= MINOR_THRESHOLD_AGE || buyMotorPolicy?.proposalNumber?.length > 0),
        //     },
        //     {
        //       type: 'text',
        //       size: 'large',
        //       colSpan: repeat === repeatForMobile ? repeat : 1,
        //       label: (
        //         <>
        //           Remarks{' '}
        //           <Text severity="error"> </Text>
        //         </>
        //       ),
        //       name: 'preinspectionDetails.remarks',
        //       // disabled: (moment(new Date(), 'DD/MM/YYYY').diff(
        //       //   moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
        //       //   'years',
        //       // ) >= MINOR_THRESHOLD_AGE || buyMotorPolicy?.proposalNumber?.length > 0),
        //       // data: (PRD_ApointRelationWithMinNomi && PRD_ApointRelationWithMinNomi?.length > 0) ? PRD_ApointRelationWithMinNomi?.map((relationship) => {
        //       //   return {
        //       //     label: relationship?.value ? relationship?.value : '',
        //       //     value: relationship?.code ? relationship?.code : ''
        //       //   }
        //       // }) : [],
        //     },
        //   ]
        // },
      // {
      //   title: 'Nominee Details',
      //   grid_data: [
      //     {
      //       type: 'text',
      //       disabled: buyMotorPolicy?.proposalNumber?.length>0,
      //       colSpan: repeat === repeatForMobile ? repeat: 1,
      //       label: (
      //         <>
      //           Nominee Name <Text severity="error"> {getDomainData(customerTypeList,buyMotorPolicy?.proposerDetails?.customerType,'code','value')?.toLowerCase() === 'individual'?'*':''}</Text>
      //         </>
      //       ),
      //       name: 'nomineeDetails.nomineeName',
      //     },
      //     {
      //       type: 'date',
      //       disabled: buyMotorPolicy?.proposalNumber?.length>0,
      //       colSpan: repeat === repeatForMobile ? repeat: 1,
      //       label: (
      //         <>
      //           Nominee Date of Birth <Text severity="error"> {getDomainData(customerTypeList,buyMotorPolicy?.proposerDetails?.customerType,'code','value')?.toLowerCase() === 'individual'?'*':''}</Text>
      //         </>
      //       ),
      //       name: 'nomineeDetails.nomineeDob',
      //       onDataChange: (val,setFieldValue) => {
      //         if (
      //           moment(new Date(), 'DD/MM/YYYY').diff(
      //             moment(val, 'DD/MM/YYYY'),
      //             'years',
      //           ) >= MINOR_THRESHOLD_AGE
      //         ) {
      //           setFieldValue(
      //             `nomineeDetails.nameOfAppointee`,
      //             '',
      //           );
      //           setFieldValue(
      //             `nomineeDetails.relationshipWithAppointee`,
      //             '',
      //           );
      //         }
      //       }
      //     },
      //     {
      //       type: 'select',
      //       size: 'large',
      //       disabled: buyMotorPolicy?.proposalNumber?.length>0,
      //       colSpan: repeat === repeatForMobile ? repeat: 1,
      //       label: (
      //         <>
      //           Relationship <Text severity="error"> {getDomainData(customerTypeList,buyMotorPolicy?.proposerDetails?.customerType,'code','value')?.toLowerCase() === 'individual'?'*':''}</Text>
      //         </>
      //       ),
      //       name: 'nomineeDetails.relationshipWithNominee',
      //       data: (PRD_NomiRelationWithMemb && PRD_NomiRelationWithMemb?.length>0)?PRD_NomiRelationWithMemb?.map((relationship) => {
      //         return {
      //           label: relationship?.value ? relationship?.value: '',
      //           value: relationship?.code ? relationship?.code: ''
      //         }
      //       }):[],
      //     },
      //     {
      //       type: 'text',
      //       disabled: buyMotorPolicy?.proposalNumber?.length>0,
      //       colSpan: repeat === repeatForMobile ? repeat: 1,
      //       label: (
      //         <>
      //           Name of Appointee <Text severity="error"> {`${(getDomainData(customerTypeList,buyMotorPolicy?.proposerDetails?.customerType,'code','value')?.toLowerCase() === 'individual' && (moment(new Date(), 'DD/MM/YYYY').diff(
      //         moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
      //         'years',
      //       ) < MINOR_THRESHOLD_AGE))?'*':''}`}</Text>
      //         </>
      //       ),
      //       name: 'nomineeDetails.nameOfAppointee',
      //       disabled: (moment(new Date(), 'DD/MM/YYYY').diff(
      //         moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
      //         'years',
      //       ) >= MINOR_THRESHOLD_AGE || buyMotorPolicy?.proposalNumber?.length>0),
      //     },
      //     {
      //       type: 'select',
      //       size: 'large',
      //       colSpan: repeat === repeatForMobile ? repeat: 1,
      //       label: (
      //         <>
      //           Relationship with Appointee{' '}
      //           <Text severity="error"> {`${(getDomainData(customerTypeList,buyMotorPolicy?.proposerDetails?.customerType,'code','value')?.toLowerCase() === 'individual' && (moment(new Date(), 'DD/MM/YYYY').diff(
      //         moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
      //         'years',
      //       ) < MINOR_THRESHOLD_AGE))?'*':''}`}</Text>
      //         </>
      //       ),
      //       name: 'nomineeDetails.relationshipWithAppointee',
      //       disabled: (moment(new Date(), 'DD/MM/YYYY').diff(
      //         moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
      //         'years',
      //       ) >= MINOR_THRESHOLD_AGE || buyMotorPolicy?.proposalNumber?.length>0),
      //       data: (PRD_ApointRelationWithMinNomi && PRD_ApointRelationWithMinNomi?.length>0)?PRD_ApointRelationWithMinNomi?.map((relationship) => {
      //         return {
      //           label: relationship?.value ? relationship?.value : '',
      //           value: relationship?.code ? relationship?.code : ''
      //         }
      //       }):[],
      //     },
      //   ],
      // },
      {
        title: 'Finance Details',
        grid_data: [
          {
            type: 'radiogroup',
            label: <>Is the Vehicle</>,
            colSpan: repeat,
            name: 'financeDetails.vehicleOwned',
            disabledGlobal:
            buyMotorPolicy?.proposalNumber?.length > 0
            && !buyMotorPolicy?.isProposalModify,
            data:
              PRD_IsYourVehicle && PRD_IsYourVehicle?.length > 0
                ? PRD_IsYourVehicle?.map((isYourVehicle) => {
                    return {
                      label: isYourVehicle?.value
                        ? isYourVehicle?.value
                        : '',
                      value: isYourVehicle?.code
                        ? isYourVehicle?.code
                        : '',
                    };
                  })
                : [],
          },
          values?.financeDetails?.vehicleOwned?.toLowerCase() ===
          'financed'
            ? {
                type: 'input-lookup',
                colSpan: repeat === repeatForMobile ? 2 : 1,
                label: <>Financer Name</>,
                size: 'large',
                name: 'financeDetails.financerDetails.financerName',
                loading: loadingFinancierName,
                onLookup: async (val, setFieldValue) => {
                  if (val.toString().length > 0) {
                    setOnUpdate((_) => {
                      const newFunc = (data) => {
                        setFieldValue(
                          `financeDetails.financerDetails.financerName`,
                        // reformData(data.value, ''),
                        reformData(data.bankName, ''),
                        );
                        setFieldValue(`financeDetails.financerDetails.financerAddress`, '',);
                        setFieldValue(`financeDetails.financerDetails.financerAgreementType`
                          , PRD_FinancerAgreementType && PRD_FinancerAgreementType.length > 0
                            ? PRD_FinancerAgreementType[0]?.code
                            : '',);
                        setFieldValue(`financeDetails.financerDetails.loanAccountNumber`, '');
                        setFieldValue(`financeDetails.financerDetails.fileNumber`, '');
                      };
                      return newFunc;
                    });
                    setSearchStringFinancierName(val);
                    try {
                      let queryOutput = fetchQuery({
                      fetchPolicy: 'network-only',
                      query: FINANCER_DROPDOWN_DETAILS_GCV,
                        variables: {
                        input: {
                          bankName: val
                        },
                      }
                      });
                      setFinancierNameOutput([]);
                      showFinancierNameModal(true);
                      setLoadingFinancierName(true);
                      let { data } = await queryOutput;
                      setLoadingFinancierName(false);
                      setFinancierNameOutput(
                      // data.getFinancierNameList,
                      data.gcvFinancierSearch.financier,
                      );
                    } catch (error) {
                      setErrors({
                        ...errors,
                        financierNameList: error?.message,
                      });
                      setLoadingFinancierName(false);
                      setFinancierNameOutput([]);
                    }
                  }
                },
                onKeyDown: (evt) => {
                  if (
                    (evt?.target?.value?.toString()?.endsWith(' ') &&
                      evt?.key === ' ') ||
                    (evt?.target?.value?.toString()?.length === 0 &&
                      evt?.key === ' ')
                  ) {
                    evt.preventDefault();
                  }
                },
                disabled:  buyMotorPolicy?.proposalNumber?.length > 0
                && !buyMotorPolicy?.isProposalModify,
              }
            : null,
          values?.financeDetails?.vehicleOwned?.toLowerCase() ===
          'financed'
            ? {
                type: 'text',
                colSpan: 2,
                label: <>Financer Address</>,
                name: 'financeDetails.financerDetails.financerAddress',
                disabled: buyMotorPolicy?.proposalNumber?.length > 0
                && !buyMotorPolicy?.isProposalModify,
                colSpan: 2,
              }
            : null,
          values?.financeDetails?.vehicleOwned?.toLowerCase() ===
          'financed'
            ? {
                type: 'select',
                size: 'large',
                colSpan: repeat === repeatForMobile ? 2 : 1,
                label: <>Financer Agreement Type </>,
                name: 'financeDetails.financerDetails.financerAgreementType',
                disabled:  buyMotorPolicy?.proposalNumber?.length > 0
                && !buyMotorPolicy?.isProposalModify,
                data:
                  PRD_FinancerAgreementType &&
                  PRD_FinancerAgreementType?.length > 0
                    ? PRD_FinancerAgreementType?.map(
                        (financerAgreementType) => {
                          return {
                            label: financerAgreementType?.value
                              ? `${financerAgreementType?.value}`
                              : '',
                            value: financerAgreementType?.code
                              ? `${financerAgreementType?.code}`
                              : '',
                          };
                        },
                      )
                    : [],
              }
            : null,
          values?.financeDetails?.vehicleOwned?.toLowerCase() ===
          'financed'
            ? {
                type: 'text',
                colSpan: repeat === repeatForMobile ? 2 : 1,
                label: <>Loan Account Number </>,
                name: 'financeDetails.financerDetails.loanAccountNumber',
                disabled:buyMotorPolicy?.proposalNumber?.length > 0
                && !buyMotorPolicy?.isProposalModify,
              }
            : null,
          values?.financeDetails?.vehicleOwned?.toLowerCase() ===
          'financed'
            ? {
                type: 'text',
                colSpan: repeat === repeatForMobile ? 2 : 1,
                label: <>File Number</>,
                name: 'financeDetails.financerDetails.fileNumber',
                disabled:  buyMotorPolicy?.proposalNumber?.length > 0
                && !buyMotorPolicy?.isProposalModify,
              }
            : null,
        ].filter((d) => d),
      },
    ].filter((b) => b);
    const uploadDocumentsData = [
  //    !buyMotorPolicy?.proposalNumber ? 
      {
        title: (
          <Text type='title' severity={'info'} className={'text-lg'} >
            Upload Documents
          </Text>
        ),
        grid_data: [
          {
            type: 'render',
            colSpan: repeat,
            component: () => {
              return (
                <Text
                  severity={'info'}
                  className={'flex space-x-2 items-center my-2'}
                >
                  <Text>
                    <FontAwesomeIcon icon={faInfoCircle} />
                  </Text>
                  <Text>
                    We support{' '}
                    <Text className={'font-semibold'}>
                      {dataDocumentExtensions?.documentExtensions
                        ?.map((extension) => extension?.value)
                        ?.join(', ')}
                    </Text>{' '}
                    formats for your documents to upload.You can
                    upload upto{' '}
                    <Text className={'font-semibold'}>
                      {
                        dataDocumentExtensions?.docFileSizeLimit
                          ?.value
                      }
                    </Text>{' '}
                    maximum size for a single file{' '}
                  </Text>
                </Text>
              );
            },
          },
          ...(values?.documentDetails &&
          values?.documentDetails?.length > 0
            ? values?.documentDetails?.map((_, idx) => {
                return {
                  type: 'render',
                  colSpan: repeat,
                  component: () => {
                    return (
                      <Paper
                        className={`bg-neutral-light shadow-md rounded border border-neutral p-4 flex flex-${
                          screenType?.toString()?.toLowerCase() ===
                          'mobile'
                            ? 'col space-y-6'
                            : 'row space-x-6'
                        }`}
                      >
                        <Text
                          className={
                            screenType?.toString()?.toLowerCase() ===
                            'mobile'
                              ? 'w-full'
                              : 'flex flex-col w-1/3'
                          }
                        >
                          <Text>
                            <QuantaSelect
                              name={`documentDetails[${idx}].documentName`}
                              size={'full'}
                              disabled={
                                buyMotorPolicy?.additionalTabDetails?.status
                                  ?.toString()
                                  ?.toLowerCase() === 'quote saved' ||
                                  buyMotorPolicy?.additionalTabDetails?.status
                                  ?.toString()
                                  ?.toLowerCase() ===
                                  'converted to proposal'
                              }
                              label={
                                <Text type={'label'}>
                                  Document Type{' '}
                                  <Text severity={'error'}></Text>
                                </Text>
                              }
                              onDataChange={(val, _) => {
                                setFieldValue(
                                  `documentDetails[${idx}].documentNameValue`,
                                  documentListCarSecure?.find(
                                    (document) =>
                                      document?.code
                                        ?.toString()
                                        ?.toLowerCase() ===
                                      val?.toString()?.toLowerCase(),
                                  )?.value,
                                );
                              }}
                              data={
                                documentListCarSecure &&
                                documentListCarSecure?.length > 0
                                  ? documentListCarSecure?.map(
                                      (document) => {
                                        return {
                                          label: document?.value
                                            ? `${document?.value}`
                                            : '',
                                          value: document?.code
                                            ? `${document?.code}`
                                            : '',
                                        };
                                      },
                                    )
                                  : []
                              }
                            />
                          </Text>
                          <Text>
                            <QuantaInput
                              name={`documentDetails[${idx}].documentDescription`}
                              size={'full'}
                              label={
                                <Text type={'label'}>
                                  Description{' '}
                                  <Text severity={'error'}>
                                    {values?.documentDetails[
                                      idx
                                    ]?.documentNameValue
                                      ?.toString()
                                      ?.toLowerCase()
                                      ?.trim() === 'others'
                                      ? '*'
                                      : ''}
                                  </Text>
                                </Text>
                              }
                              disabled={
                                buyMotorPolicy?.additionalTabDetails?.status
                                  ?.toString()
                                  ?.toLowerCase() === 'quote saved' ||
                                  buyMotorPolicy?.additionalTabDetails?.status
                                  ?.toString()
                                  ?.toLowerCase() ===
                                  'converted to proposal'
                              }
                              placeholder={
                                'Type description if others'
                              }
                              onKeyDown={(evt) => {
                                if (
                                  (evt?.target?.value
                                    ?.toString()
                                    ?.endsWith(' ') &&
                                    evt?.key === ' ') ||
                                  (evt?.target?.value?.toString()
                                    ?.length === 0 &&
                                    evt?.key === ' ')
                                ) {
                                  evt.preventDefault();
                                }
                              }}
                            />
                          </Text>
                        </Text>
                        <span
                          onDragEnter={(evt) => {
                            evt.preventDefault();
                            evt.stopPropagation();
                            if (
                              values?.documentDetails[idx]
                                ?.documentName
                            ) {
                              setFieldValue(
                                `documentDetails[${idx}].dragCounter`,
                                values?.documentDetails[idx]
                                  ?.dragCounter + 1,
                              );
                              if (
                                evt?.dataTransfer?.items?.length > 0
                              ) {
                                setFieldValue(
                                  `documentDetails[${idx}].dragging`,
                                  true,
                                );
                              }
                            }
                          }}
                          onDragLeave={(evt) => {
                            evt.preventDefault();
                            evt.stopPropagation();
                            if (
                              values?.documentDetails[idx]
                                ?.documentName
                            ) {
                              if (
                                values?.documentDetails[idx]
                                  ?.dragCounter === 1
                              ) {
                                setFieldValue(
                                  `documentDetails[${idx}].dragging`,
                                  false,
                                );
                              }
                              setFieldValue(
                                `documentDetails[${idx}].dragCounter`,
                                values?.documentDetails[idx]
                                  ?.dragCounter - 1,
                              );
                            }
                          }}
                          onDragOver={(evt) => {
                            evt.preventDefault();
                            evt.stopPropagation();
                          }}
                          onDrop={(evt) => {
                            evt.preventDefault();
                            evt.stopPropagation();
                            if (
                              values?.documentDetails[idx]
                                ?.documentName &&
                              evt?.dataTransfer?.files?.length > 0
                            ) {
                              if (
                                documentExtensions?.find(
                                  (extension) =>
                                    extension?.value
                                      ?.toString()
                                      ?.toLowerCase() ===
                                    evt?.dataTransfer?.files[0]?.name
                                      ?.split('.')
                                      .pop()
                                      ?.toString()
                                      ?.toLowerCase(),
                                )
                              ) {
                                let reader = new FileReader();
                                const file =
                                  evt?.dataTransfer?.files[0];
                                if (
                                  file?.size / 1024 <=
                                  parseFloat(docFileSizeLimit?.code)
                                ) {
                                  setFieldValue(
                                    `documentDetails[${idx}].documentExtension`,
                                    documentExtensions?.find(
                                      (extension) =>
                                        extension?.value
                                          ?.toString()
                                          ?.toLowerCase() ===
                                        file?.name
                                          ?.split('.')
                                          .pop()
                                          ?.toString()
                                          ?.toLowerCase(),
                                    )?.code,
                                  );
                                  setFieldValue(
                                    `documentDetails[${idx}].documentSize`,
                                    parseFloat(
                                      parseFloat(
                                        file?.size / 1024,
                                      )?.toFixed(2),
                                    ),
                                  );
                                  setFieldValue(
                                    `documentDetails[${idx}].documentSizeinKB`,
                                    `${parseFloat(
                                      parseFloat(
                                        file?.size / 1024,
                                      )?.toFixed(2),
                                    )} Kb`,
                                  );
                                  setFieldValue(
                                    `documentDetails[${idx}].documentFileName`,
                                    file?.name?.split('.')[0],
                                  );
                                  setFieldValue(
                                    `documentDetails[${idx}].documentFileNameWithExtension`,
                                    file?.name,
                                  );
                                  reader.readAsDataURL(file);
                                  reader.onload = () => {
                                    setFieldValue(
                                      `documentDetails[${idx}].documentBase64String`,
                                      reader.result,
                                    );
                                  };
                                  //evt.dataTransfer.clearData();
                                  setFieldValue(
                                    `documentDetails[${idx}].dragCounter`,
                                    0,
                                  );
                                  setFieldValue(
                                    `documentDetails[${idx}].dragging`,
                                    false,
                                  );
                                  uploadDocRef.current = [
                                    ...uploadDocRef?.current?.filter(
                                      (ref) =>
                                        parseInt(
                                          ref?.id?.toString(),
                                        ) !== idx,
                                    ),
                                  ];
                                } else {
                                  setAlerts([
                                    {
                                      id: Date.now(),
                                      header:
                                        'Error fetching document',
                                      content: (
                                        <Text>
                                          File size is larger than{' '}
                                          {docFileSizeLimit?.value}
                                        </Text>
                                      ),
                                      type: 'error',
                                      timeout: 4000,
                                      disableClose: false,
                                    },
                                  ]);
                                  setFieldValue(
                                    `documentDetails[${idx}].dragCounter`,
                                    0,
                                  );
                                  setFieldValue(
                                    `documentDetails[${idx}].dragging`,
                                    false,
                                  );
                                  uploadDocRef.current = [];
                                }
                              } else {
                                //evt.dataTransfer.clearData();
                                setFieldValue(
                                  `documentDetails[${idx}].dragCounter`,
                                  0,
                                );
                                setFieldValue(
                                  `documentDetails[${idx}].dragging`,
                                  false,
                                );
                                setAlerts([
                                  {
                                    id: Date.now(),
                                    content: (
                                      <Text>
                                        Input file Format is not
                                        supported
                                      </Text>
                                    ),
                                    type: 'error',
                                    disableClose: false,
                                    timeout: 4000,
                                  },
                                  ...alerts,
                                ]);
                                uploadDocRef.current = [
                                  ...uploadDocRef?.current?.filter(
                                    (ref) =>
                                      parseInt(
                                        ref?.id?.toString(),
                                      ) !== idx,
                                  ),
                                ];
                              }
                            }
                          }}
                          className={`w-full my-1 border-2 border-dotted border-secondary justify-center flex flex-col ${
                            screenType?.toString()?.toLowerCase() ===
                            'mobile'
                              ? 'flex-wrap'
                              : ''
                          } p-4`}
                        >
                          <Text
                            className={
                              values?.documentDetails[idx]?.dragging
                                ? 'text-2xl text-neutral-darker flex justify-center'
                                : ''
                            }
                          >
                            {values?.documentDetails[idx]
                              ?.dragging ? (
                              'Drop here'
                            ) : values?.documentDetails[idx]
                                ?.documentFileName ? (
                              <Text className={'flex flex-col'}>
                                <Text className={'flex flex-wrap'}>
                                  <Text>File Name:&nbsp;</Text>
                                  <Text
                                    severity={'info'}
                                    className={
                                      'font-semibold break-normal'
                                    }
                                  >{`${
                                    values?.documentDetails[idx]
                                      ?.documentFileName
                                  }.${
                                    documentExtensions?.find(
                                      (extension) =>
                                        extension?.code
                                          ?.toString()
                                          ?.toLowerCase() ===
                                        values?.documentDetails[
                                          idx
                                        ]?.documentExtension
                                          ?.toString()
                                          ?.toLowerCase(),
                                    )?.value
                                  }`}</Text>
                                </Text>
                                <Text>
                                  File Size:&nbsp;
                                  <Text className={'font-semibold'}>
                                    {`${values?.documentDetails[idx]?.documentSize}`}{' '}
                                    KB
                                  </Text>
                                </Text>
                              </Text>
                            ) : (
                              `${
                                screenType
                                  ?.toString()
                                  ?.toLowerCase() !== 'desktop'
                                  ? 'Click the browse button to select a file'
                                  : `Drag and drop your document here to
                                upload. Alternatively you can browse
                                the file by clicking the button`
                              }`
                            )}
                          </Text>
                          {!values?.documentDetails[idx]?.dragging &&
                          !values?.documentDetails[idx]
                            ?.documentFileName ? (
                            <Text
                              className={`flex ${
                                screenType
                                  ?.toString()
                                  ?.toLowerCase() === 'mobile'
                                  ? 'flex-col space-y-2'
                                  : 'space-x-2'
                              } justify-end ${
                                screenType
                                  ?.toString()
                                  ?.toLowerCase() === 'mobile'
                                  ? 'w-full mt-4'
                                  : ''
                              }`}
                            >
                              {values?.documentDetails?.length >
                                1 && (
                                <Text>
                                  <Button
                                    size={'small'}
                                    flat={true}
                                    className={`h-10 w-24 w-${
                                      screenType
                                        ?.toString()
                                        ?.toLowerCase() === 'mobile'
                                        ? 'full'
                                        : '24'
                                    }`}
                                    onClick={(_) => {
                                      if (
                                        values?.documentDetails
                                          ?.length > 1
                                      ) {
                                        setFieldValue(
                                          `documentDetails`,
                                          [
                                            ...values?.documentDetails?.slice(
                                              0,
                                              idx,
                                            ),
                                            ...values?.documentDetails?.slice(
                                              idx + 1,
                                            ),
                                          ],
                                        );
                                        uploadDocRef.current = [
                                          ...uploadDocRef?.current?.filter(
                                            (ref) =>
                                              parseInt(
                                                ref?.id?.toString(),
                                              ) !== idx,
                                          ),
                                        ];
                                      }
                                    }}
                                  >
                                    Cancel
                                  </Button>
                                </Text>
                              )}
                              <Text>
                                <Button
                                  size={'small'}
                                  type={'button'}
                                  flat={false}
                                  className={`h-10 w-24 w-${
                                    screenType
                                      ?.toString()
                                      ?.toLowerCase() === 'mobile'
                                      ? 'full'
                                      : '24'
                                  }`}
                                  disabled={
                                    buyMotorPolicy?.additionalTabDetails?.status
                                      ?.toString()
                                      ?.toLowerCase() ===
                                      'quote saved' ||
                                      buyMotorPolicy?.additionalTabDetails?.status
                                      ?.toString()
                                      ?.toLowerCase() ===
                                      'converted to proposal' ||
                                    !values?.documentDetails[idx]
                                      ?.documentName
                                      ? true
                                      : false
                                  }
                                  onClick={(_) => {
                                    uploadDocRef?.current
                                      ?.find(
                                        (ref) =>
                                          parseInt(
                                            ref?.id?.toString(),
                                          ) === idx,
                                      )
                                      ?.click();
                                  }}
                                >
                                  Browse
                                  <input
                                    key={idx}
                                    id={idx}
                                    ref={(ref) => {
                                      if (
                                        !uploadDocRef?.current?.find(
                                          (r) => r?.id === ref?.id,
                                        ) &&
                                        ref
                                      ) {
                                        uploadDocRef?.current?.push(
                                          ref,
                                        );
                                      }
                                    }}
                                    className="hidden"
                                    type="file"
                                    accept={`${documentExtensions
                                      ?.map(
                                        (extension) =>
                                          `.${extension?.value}`,
                                      )
                                      ?.join(',')}`}
                                    disabled={
                                      !values?.documentDetails[idx]
                                        ?.documentName
                                        ? true
                                        : false
                                    }
                                    onChange={(evt) => {
                                      if (
                                        evt?.target?.files?.length > 0
                                      ) {
                                        let reader = new FileReader();
                                        const file =
                                          evt?.target?.files[0];
                                        if (
                                          file?.size / 1024 <=
                                          parseFloat(
                                            docFileSizeLimit?.code,
                                          )
                                        ) {
                                          setFieldValue(
                                            `documentDetails[${idx}].documentExtension`,
                                            documentExtensions?.find(
                                              (extension) =>
                                                extension?.value
                                                  ?.toString()
                                                  ?.toLowerCase() ===
                                                file?.name
                                                  ?.split('.')
                                                  .pop()
                                                  ?.toString()
                                                  ?.toLowerCase(),
                                            )?.code,
                                          );
                                          setFieldValue(
                                            `documentDetails[${idx}].documentSize`,
                                            parseFloat(
                                              parseFloat(
                                                file?.size / 1024,
                                              )?.toFixed(2),
                                            ),
                                          );
                                          setFieldValue(
                                            `documentDetails[${idx}].documentSizeinKB`,
                                            `${parseFloat(
                                              parseFloat(
                                                file?.size / 1024,
                                              )?.toFixed(2),
                                            )} Kb`,
                                          );
                                          setFieldValue(
                                            `documentDetails[${idx}].documentFileName`,
                                            file?.name?.split('.')[0],
                                          );
                                          setFieldValue(
                                            `documentDetails[${idx}].documentFileNameWithExtension`,
                                            file?.name,
                                          );
                                          reader.readAsDataURL(file);
                                          reader.onload = () => {
                                            setFieldValue(
                                              `documentDetails[${idx}].documentBase64String`,
                                              reader.result,
                                            );
                                          };
                                          setFieldValue(
                                            `documentDetails[${idx}].dragCounter`,
                                            0,
                                          );
                                          uploadDocRef.current = [
                                            ...uploadDocRef?.current?.filter(
                                              (ref) =>
                                                parseInt(
                                                  ref?.id?.toString(),
                                                ) !== idx,
                                            ),
                                          ];
                                        } else {
                                          setAlerts([
                                            {
                                              id: Date.now(),
                                              header:
                                                'Error fetching document',
                                              content: (
                                                <Text>
                                                  File size is larger
                                                  than{' '}
                                                  {
                                                    docFileSizeLimit?.value
                                                  }
                                                </Text>
                                              ),
                                              type: 'error',
                                              timeout: 4000,
                                              disableClose: false,
                                            },
                                          ]);
                                          uploadDocRef.current = [];
                                        }
                                      }
                                      evt.target.value = '';
                                    }}
                                  />
                                </Button>
                              </Text>
                            </Text>
                          ) : values?.documentDetails[idx]
                              ?.documentFileName &&
                            !values?.documentDetails[idx]
                              ?.dragging ? (
                            <Text
                              className={
                                screenType
                                  ?.toString()
                                  ?.toLowerCase() === 'mobile'
                                  ? 'w-full mt-4'
                                  : ''
                              }
                              severity={'action'}
                            >
                              <Text
                                className={`flex ${
                                  screenType
                                    ?.toString()
                                    ?.toLowerCase() === 'mobile'
                                    ? 'flex-col space-y-2'
                                    : 'space-x-2'
                                } justify-end ${
                                  screenType
                                    ?.toString()
                                    ?.toLowerCase() === 'mobile'
                                    ? 'w-full mt-4'
                                    : ''
                                }`}
                              >
                                {values?.documentDetails?.length >
                                  1 && (
                                  <Text>
                                    <Button
                                      size={'small'}
                                      flat={true}
                                      className={`h-10 w-24 w-${
                                        screenType
                                          ?.toString()
                                          ?.toLowerCase() === 'mobile'
                                          ? 'full'
                                          : '24'
                                      }`}
                                      onClick={(_) => {
                                        if (
                                          values?.documentDetails
                                            ?.length > 1
                                        ) {
                                          setFieldValue(
                                            `documentDetails`,
                                            [
                                              ...values?.documentDetails?.slice(
                                                0,
                                                idx,
                                              ),
                                              ...values?.documentDetails?.slice(
                                                idx + 1,
                                              ),
                                            ],
                                          );
                                          uploadDocRef.current = [
                                            ...uploadDocRef?.current?.filter(
                                              (ref) =>
                                                parseInt(
                                                  ref?.id?.toString(),
                                                ) !== idx,
                                            ),
                                          ];
                                        }
                                      }}
                                    >
                                      Cancel
                                    </Button>
                                  </Text>
                                )}
                                <Text>
                                  <Button
                                    disabled={
                                      buyMotorPolicy?.additionalTabDetails?.status
                                        ?.toString()
                                        ?.toLowerCase() ===
                                        'quote saved' ||
                                        buyMotorPolicy?.additionalTabDetails?.status
                                        ?.toString()
                                        ?.toLowerCase() ===
                                        'pending uw approval' ||
                                        buyMotorPolicy?.additionalTabDetails?.status
                                        ?.toString()
                                        ?.toLowerCase() ===
                                        'underwriter rejected' ||
                                        buyMotorPolicy?.additionalTabDetails?.status
                                        ?.toString()
                                        ?.toLowerCase() ===
                                        'underwriter approved' ||
                                        buyMotorPolicy?.additionalTabDetails?.status
                                        ?.toString()
                                        ?.toLowerCase() ===
                                        'converted to proposal'
                                    }
                                    size={'small'}
                                    flat={true}
                                    className={`h-10 w-24 w-${
                                      screenType
                                        ?.toString()
                                        ?.toLowerCase() === 'mobile'
                                        ? 'full'
                                        : '24'
                                    }`}
                                    onClick={(_) => {
                                      setFieldValue(
                                        `documentDetails[${idx}].documentFileName`,
                                        '',
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].documentFileNameWithExtension`,
                                        '',
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].documentExtension`,
                                        '',
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].documentSize`,
                                        null,
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].documentSizeinKB`,
                                        '',
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].dragging`,
                                        false,
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].dragCounter`,
                                        0,
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].documentBase64String`,
                                        '',
                                      );
                                    }}
                                  >
                                    Delete
                                  </Button>
                                </Text>
                              </Text>
                            </Text>
                          ) : null}
                        </span>
                      </Paper>
                    );
                  },
                };
              })
            : []),
          {
            type: 'render',
            colSpan: repeat,
            component: () => {
              return (
                <Text className={'flex flex-col w-full space-y-2'}>
                  <Text>
                    <Button
                      flat={true}
                      size={'small'}
                      className={
                        screenType?.toString()?.toLowerCase() ===
                        'mobile'
                          ? 'w-full h-10'
                          : 'h-10'
                      }
                      disabled={
                        buyMotorPolicy?.additionalTabDetails?.status
                          ?.toString()
                          ?.toLowerCase() === 'quote saved' ||
                          buyMotorPolicy?.additionalTabDetails?.status
                          ?.toString()
                          ?.toLowerCase() === 'pending uw approval' ||
                          buyMotorPolicy?.additionalTabDetails?.status
                          ?.toString()
                          ?.toLowerCase() ===
                          'underwriter rejected' ||
                          buyMotorPolicy?.additionalTabDetails?.status
                          ?.toString()
                          ?.toLowerCase() ===
                          'underwriter approved' ||
                          buyMotorPolicy?.additionalTabDetails?.status
                          ?.toString()
                          ?.toLowerCase() === 'converted to proposal'
                      }
                      onClick={(_) => {
                        setFieldValue('documentDetails', [
                          ...values?.documentDetails,
                          {
                            documentDescription: '',
                            documentName: '',
                            documentNameValue: '',
                            documentFileName: '',
                            documentFileNameWithExtension: '',
                            documentExtension: '',
                            documentSize: null,
                            documentSizeinKB: '',
                            dragging: false,
                            dragCounter: 0,
                            documentBase64String: '',
                          },
                        ]);
                      }}
                    >
                      Add More Document
                    </Button>
                  </Text>
                </Text>
              );
            },
          },
        ],
      } ,
    ].filter((d) => d);

    const other_props = {
      flow: 'cols',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      textType: 'normal',
      nullData: () => <Text severity="neutral">Not Captured</Text>,
    };
    const otherPropsForCards = {
      flow: 'cols',
      textType: 'normal',
      repeat: repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      titleType: 'normal',
      useExpandablePaper: false,
      useGlobalExpandablePaper: true,
      globalTitleSeverity: 'info',
      globalTitleType: 'large',
      nullData: () => <Text severity="neutral">Not Captured</Text>,
    };
    const uploadDocumentsDataProps = {
      flow: 'cols',
      repeat: repeat,
      gapX: 4,
      gapY: 4,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
    };
    return (
      <>
        <QuantaForm className="space-y-4 mt-3">
          <MixedGridGroup {...{ data, ...other_props }} />
          {(!buyMotorPolicy?.proposalNumber
            || buyMotorPolicy?.isProposalModify)
            && 
          (<InputGridGroup
          {...{
                data: uploadDocumentsData,
                ...uploadDocumentsDataProps,
          }}
            />
            )}
        </QuantaForm>
        <div>
          <SearchResultsModal
            {...{
              modalSizeExternal,
              modalDisplay: financierNameModalDisplay,
              isFormWrapFlag: true,
              searchInput,
              searchResults,
              paginationInput,
              title: 'Search Financer Name',
              onClose,
              onDataUpdate,
              onNoResultsFound,
              onMessage,
              selectOnRowClick: true,
              firstRowClickRequired: false,
            }}
          />
        </div>
      </>
    );
  };
  const getCalculatePremiumForProposalVariables = (values) => {
    let riskInput = [];
    buyMotorPolicy?.coverData?.rawRiskData?.forEach((r) => {
      let covers = [];
      r.covers
        .filter(
          (c) =>
            buyMotorPolicy?.coverData?.addOnCovers[c?.name]?.selected,
        )
        .forEach((c) => {
          const { selected, attributes, ...rest } = c;
          let attributesArr = [];
          c?.attributes?.forEach((attribute) => {
            attributesArr.push({
              ...attribute,
              value: attribute?.showOnScreen
                ? `${
                    buyMotorPolicy?.coverData?.addOnCovers[
                      `${c?.name}`
                    ][`attributes`][`${attribute?.name}`]
                  }`
                : `${attribute?.defaultValue}`,
            });
          });
          covers.push({
            ...rest,
            attributes: [...attributesArr],
          });
        });
      if (covers?.length !== 0) {
        riskInput.push({
          riskType: r?.riskType,
          covers,
        });
      }
    });
    let ownerDriverSelected='false';
    if (buyMotorPolicy?.coverData?.addOnCovers[`Owner Driver`]?.selected)
             {
              ownerDriverSelected= 'true'
             }
  let  trailerArr = [];
  buyMotorPolicy?.quoteData?.trailerDetails?.forEach((_, idx) => {
   trailerArr.push({
       make:buyMotorPolicy?.quoteData?.trailerDetails[idx].make,
       model: buyMotorPolicy?.quoteData?.trailerDetails[idx].model,
       regnumber: buyMotorPolicy?.quoteData?.trailerDetails[idx].regnumber,
       ChassisNumber: buyMotorPolicy?.quoteData?.trailerDetails[idx].ChassisNumber,
       SI: buyMotorPolicy?.quoteData?.trailerDetails[idx].SI,
       yearofmanufacture:buyMotorPolicy?.quoteData?.trailerDetails[idx].yearofmanufacture,
     });
   });
   /** SU - Commented StartDate Logic : replaced with startdate value from calculate Premium response */
  //  if (moment(values?.previousInsuranceAndClaims?.previousPolicyDetails?.policyExpiryDate, "DD/MM/YYYY").isSame(
  //   moment(moment(new Date(), 'DD/MM/YYYY')?.format('DD/MM/YYYY'), 'DD/MM/YYYY'))) {
  //   startDate_min = moment(new Date(), "DD/MM/YYYY")?.add(1, 'days')?.format('DD/MM/YYYY');
  // } else if ((moment(values?.previousInsuranceAndClaims?.previousPolicyDetails?.policyExpiryDate,
  //   "DD/MM/YYYY").isBefore(moment(new Date(), 'DD/MM/YYYY')))&&
  //   moment(new Date(),'DD/MM/YYYY').diff(moment(values?.previousInsuranceAndClaims?.previousPolicyDetails?.policyExpiryDate,"DD/MM/YYYY"),'days')!=1) {
  //       if( buyMotorPolicy?.quoteData?.productVariant?.toLowerCase()?.search('liability') !== -1 ){
  //         startDate_min = moment(new Date(), "DD/MM/YYYY")?.add(2, 'days')?.format('DD/MM/YYYY');
  //       }else if(buyMotorPolicy?.quoteData?.productVariant?.toLowerCase()?.search('comprehensive') !== -1 ){
  //   startDate_min = moment().format('DD/MM/YYYY');
  //       }
  // } else if (moment(values?.previousInsuranceAndClaims?.previousPolicyDetails?.policyExpiryDate,
  //   "DD/MM/YYYY").isAfter(moment(new Date(), 'DD/MM/YYYY'))) {
  //   startDate_min = moment(values?.previousInsuranceAndClaims?.previousPolicyDetails?.policyExpiryDate,
  //     "DD/MM/YYYY")?.add(1, 'days')?.format('DD/MM/YYYY');
  // }
  // if(moment(new Date(), 'DD/MM/YYYY').diff(moment(values?.previousInsuranceAndClaims?.previousPolicyDetails?.policyExpiryDate,"DD/MM/YYYY"),'days') ==2
  // &&buyMotorPolicy?.quoteData?.productVariant?.toLowerCase()?.search('comprehensive') === -1){
  //   startDate_min = moment(new Date(), "DD/MM/YYYY")?.add(2, 'days')?.format('DD/MM/YYYY');
  // }
  // if((buyMotorPolicy?.businessType?.toLowerCase()=='roll over'
  //   ||buyMotorPolicy?.businessTypeValue?.toLowerCase()=='roll over')&&(buyMotorPolicy?.quoteData?.anyPreviousPolicyforVehicleTaken?.toString()=='No')
  //   &&buyMotorPolicy?.quoteData?.productVariant?.toLowerCase()?.search('comprehensive') === -1){
  //   startDate_min = moment(new Date(), "DD/MM/YYYY")?.add(2, 'days')?.format('DD/MM/YYYY');
  // }
  // if((buyMotorPolicy?.businessType?.toLowerCase()=='roll over'
  //   ||buyMotorPolicy?.businessTypeValue?.toLowerCase()=='roll over')&&(buyMotorPolicy?.quoteData?.anyPreviousPolicyforVehicleTaken?.toString()=='No')
  //   &&buyMotorPolicy?.quoteData?.productVariant?.toLowerCase()?.search('comprehensive') !== -1){
  //   startDate_min = moment()?.format('DD/MM/YYYY');
  // }
  /** EU - Commented StartDate Logic*/
    return {
      input: {
        // productCode,
        productCode
        :buyMotorPolicy?.quoteData?.productVariant?.toLowerCase()?.search('comprehensive') !== -1
        ?'3137'
        :buyMotorPolicy?.quoteData?.productVariant?.toLowerCase()?.search('liability') !== -1
        ?'3140'
        
        :'3137',
        productType: buyMotorPolicy?.quoteData?.productType
          ? `${buyMotorPolicy?.quoteData?.productType}`
          : '',
        customerType: buyMotorPolicy?.proposerDetails?.customerType
          ? `${buyMotorPolicy?.proposerDetails?.customerType}`
          : '',
        gender: buyMotorPolicy?.proposerDetails?.gender
          ? `${buyMotorPolicy?.proposerDetails?.gender}`
          : '',
        businessType: buyMotorPolicy?.quoteData?.businessType
          ? `${buyMotorPolicy?.quoteData?.businessType}`
          : '',
        intermediary: {
          intermediaryCode: intermediaryDetails?.code
            ? `${intermediaryDetails?.code}`
            : '',
          locationCode: intermediaryDetails?.location
            ? `${intermediaryDetails?.location}`
            : '',
          fieldUserCode: intermediaryDetails?.fieldUserCode
            ? `${intermediaryDetails?.fieldUserCode}`
            : '',
        },
        isTrailerRequired:buyMotorPolicy?.quoteData?.isTrailerRequired
        ?buyMotorPolicy?.quoteData?.isTrailerRequired
        :false,
        nooftrailers:buyMotorPolicy?.quoteData?.nooftrailers
        ?buyMotorPolicy?.quoteData?.nooftrailers
        :'',
        towedby:buyMotorPolicy?.quoteData?.towedby
        ?buyMotorPolicy?.quoteData?.towedby
        :'',
        totalIDV:buyMotorPolicy?.quoteData?.totalIDV,
        bodyIDV:buyMotorPolicy?.quoteData?.bodyIDV,
        coverforlamps:buyMotorPolicy?.quoteData?.coverforlamps
        ?buyMotorPolicy?.quoteData?.coverforlamps
        :false,
        coverforprivateandcommercial:buyMotorPolicy?.quoteData?.coverforprivateandcommercial
        ?buyMotorPolicy?.quoteData?.coverforprivateandcommercial
        :false,
        vehicleusedlimitedtoownpremises:buyMotorPolicy?.quoteData?.vehicleusedlimitedtoownpremises
        ?buyMotorPolicy?.quoteData?.vehicleusedlimitedtoownpremises
        :false,
        vehicleuseddrivingtuitions:buyMotorPolicy?.quoteData?.vehicleuseddrivingtuitions
        ?buyMotorPolicy?.quoteData?.vehicleuseddrivingtuitions
        :false,
        ImportedVehicle:buyMotorPolicy?.quoteData?.ImportedVehicle
        ?buyMotorPolicy?.quoteData?.ImportedVehicle
        :false,
        ConfinedtoOwnPremises:buyMotorPolicy?.quoteData?.ConfinedtoOwnPremises
        ?buyMotorPolicy?.quoteData?.ConfinedtoOwnPremises
        :false,
        SoftCopyDiscount:buyMotorPolicy?.quoteData?.SoftCopyDiscount
        ?buyMotorPolicy?.quoteData?.SoftCopyDiscount
        :false,
        AntiTheftDiscount:buyMotorPolicy?.quoteData?.AntiTheftDiscount
        ?buyMotorPolicy?.quoteData?.AntiTheftDiscount
        :false,
        tenure:
          buyMotorPolicy?.quoteData?.tenure ||
          buyMotorPolicy?.quoteData?.premiumData?.tenure
            ? `${
                buyMotorPolicy?.quoteData?.tenure ||
                buyMotorPolicy?.quoteData?.premiumData?.tenure
              }`
            : '',
        rto: {
          rtoAuthCode: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoAuthorityCode
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoAuthorityCode}`
            : '',
          rtoLocCode: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoLocationCode
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoLocationCode}`
            : '',
          rtoLocDesc: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoLocationDesc
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoLocationDesc}`
            : '',
        },
        vehicle: {
          make: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
            ?.make?.code
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.make?.code}`
            : '',
          model: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
            ?.model?.code
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.model?.code}`
            : '',
          variant: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
            ?.variant?.code
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.variant?.code}`
            : '',
          engineNumber: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.engineNumber
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.engineNumber}`
            : '',
          chasisNumber: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.chasisNumber
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.chasisNumber}`
            : '',
            preInspectionNumber: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.preInspectionNumber
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.preInspectionNumber}`
            : '',
          registrationNumber: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.registrationNumber
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumber}`
            : '',
           registrationNumberOthers: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.registrationNumberOthers
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumberOthers}`
            : '', 
          manufactureYear: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.yearOfManufacture
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.yearOfManufacture}`
            : '',
          regPurchaseDate: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.dateOfRegistration
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.dateOfRegistration}`
            : '',
          fuelType: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
            ?.fuelType
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.fuelType}`
            : '',
          seatingCapacity: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.seatingCapacity
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.seatingCapacity}`
            : '',
          cubicCapacity: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.cubeCapacity
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.cubeCapacity}`
            : '',
            carryingCapacity:buyMotorPolicy?.quoteData?.carryingCapacity
            ? `${buyMotorPolicy?.quoteData?.carryingCapacity}`
            : '',
            gvw:buyMotorPolicy?.quoteData?.changedGVW
            ? `${buyMotorPolicy?.quoteData?.changedGVW}`
            : buyMotorPolicy?.quoteData?.gvw,
            carriageType:buyMotorPolicy?.quoteData?.carriageType?.code
            ? `${buyMotorPolicy?.quoteData?.carriageType?.code}`
            : '',
            permitType:buyMotorPolicy?.quoteData?.permitType?.code
          
            ? `${buyMotorPolicy?.quoteData?.permitType?.code}`
            : '',
            vehicleuse:buyMotorPolicy?.quoteData?.vehicleuse?.code
            ? `${buyMotorPolicy?.quoteData?.vehicleuse?.code}`
            : '',
            vehiclesubType:buyMotorPolicy?.quoteData?.vehiclesubType?.code
            ? `${buyMotorPolicy?.quoteData?.vehiclesubType?.code}`
            : '',
            natureofgoods:buyMotorPolicy?.quoteData?.natureofgoods?.code
            ?`${buyMotorPolicy?.quoteData?.natureofgoods?.code}`
            : '',
        },
        firstYearIDV:
          buyMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails
            ?.vehicleIDV !== null &&
          buyMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails
            ?.vehicleIDV !== undefined
            ? `${buyMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails?.vehicleIDV}`
            : ``,
        irf1: buyMotorPolicy?.vehicleTabDetails
          ?.insuredDeclaredDetails?.irfAdjustmentPercent
          ? `${buyMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails?.irfAdjustmentPercent}`
          : '',
        prevInsurance: {
          coverType: quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'&&
          values?.previousInsuranceAndClaims
            ?.previousPolicyDetails?.policyCoverType
            ? `${values?.previousInsuranceAndClaims?.previousPolicyDetails?.policyCoverType}`
            : '',
          policyTenure: quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'&&
          values?.previousInsuranceAndClaims
            ?.previousPolicyDetails?.policyTenure
            ? `${values?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenure}`
            : '',
          insurerName: quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'&&
          values?.previousInsuranceAndClaims
            ?.previousPolicyDetails?.previousInsurerName
            ? `${values?.previousInsuranceAndClaims?.previousPolicyDetails?.previousInsurerName}`
            : '',
          policyNumber: quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'&&
          values?.previousInsuranceAndClaims
            ?.previousPolicyDetails?.expiringPolicyNumber
            ? `${values?.previousInsuranceAndClaims?.previousPolicyDetails?.expiringPolicyNumber}`
            : '',
          startDate:quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'&&
           values?.previousInsuranceAndClaims
            ?.previousPolicyDetails?.policyStartDate
            ? `${values?.previousInsuranceAndClaims?.previousPolicyDetails?.policyStartDate}`
            : '',
          expiryDate: quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'&&
          values?.previousInsuranceAndClaims
            ?.previousPolicyDetails?.policyExpiryDate
            ? `${values?.previousInsuranceAndClaims?.previousPolicyDetails?.policyExpiryDate}`
            : '',
            PypPolicyTenureTP:quoteData?.TP_Policy_Tenure
            ? quoteData?.TP_Policy_Tenure
            :'',
            PypStartDateTP: quoteData?.TP_Start_Date
            ? quoteData?.TP_Start_Date
            :'',
            PypEndDateTP: quoteData?.TP_End_Date
            ? quoteData?.TP_End_Date
            :'',
            PypInsurerTP:values?.previousInsuranceAndClaims.previousPolicyDetails.TPpreviousInsurerName,
            TPPolicyNo:values?.previousInsuranceAndClaims.previousPolicyDetails.TPexpiringPolicyNumber
        },
        prevClaims: {
          totalClaimCount:quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'&&
          values?.previousInsuranceAndClaims?.previousClaims?.totalClaimCount ?
            `${values?.previousInsuranceAndClaims?.previousClaims?.totalClaimCount}`
              : '',
          claimsInYear1:
          quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes' &&
          values?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear1 ?
          `${values?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear1}`
              : '',
          claimsInYear2:
          quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'&&
              values?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear2
              ? `${values?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear2}`
              : '',
          claimsInYear3:
          quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'&&
              values?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear3
              ? `${values?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear3}`
              : '',
          prevNCBSlab:  quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'?
          `${
            values?.previousInsuranceAndClaims?.previousClaims?.previousYearNCBSlab}`
            :'',
          claimFreeYear:
            buyMotorPolicy?.quoteData?.premiumData?.claimFreeYear ||
            buyMotorPolicy?.premiumData?.claimFreeYear,
          totalClaimAmount:
            values?.previousInsuranceAndClaims?.previousClaims
              ?.totalClaimAmount !== undefined &&
            values?.previousInsuranceAndClaims?.previousClaims
              ?.totalClaimAmount !== null
              ? parseFloat(
                  values?.previousInsuranceAndClaims?.previousClaims
                    ?.totalClaimAmount,
                )
              : null,
        },
        financerDetails: {
          financerName:
            values?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? values?.financeDetails?.financerDetails?.financerName
              : '',
          financerAddress:
            values?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? values?.financeDetails?.financerDetails
                  ?.financerAddress
              : '',
          financerAgreementType:
            values?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? values?.financeDetails?.financerDetails
                  ?.financerAgreementType
              : '',
          loanAccountNumber:
            values?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? values?.financeDetails?.financerDetails
                  ?.loanAccountNumber
              : '',
          fileNumber:
            values?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? values?.financeDetails?.financerDetails?.fileNumber
              : '',
        },
        trailerDetails:trailerArr,
        riskCovers: riskInput,
        ownerDriverSelected:ownerDriverSelected,
        creditScore: {
          discountOpted:
            buyMotorPolicy?.quoteData?.getAdditionalCreditScore ===
            'Yes',
          idProofType: buyMotorPolicy?.quoteData?.idProofType,
          idProofNumber: buyMotorPolicy?.quoteData?.idProofNumber,
          creditScore:
            buyMotorPolicy?.quoteData?.premiumData?.creditScore !==
              null &&
            buyMotorPolicy?.quoteData?.premiumData?.creditScore !==
              undefined
              ? parseFloat(
                  buyMotorPolicy?.quoteData?.premiumData?.creditScore,
                )
              : null,
        },
        proposerPincode: buyMotorPolicy?.proposerDetails?.permPincode,
        voluntaryDeductibleAmt:
          buyMotorPolicy?.quoteData?.voluntaryDeductibleAmount !==
            null &&
          buyMotorPolicy?.quoteData?.voluntaryDeductibleAmount !==
            undefined
            ? parseFloat(
                buyMotorPolicy?.quoteData?.voluntaryDeductibleAmount,
              )
            : null,
        quoteNumber: buyMotorPolicy?.quoteNumber,
        nomineeDetails: {
          name: ownerDriverSelected=='true'?
          values?.nomineeDetails?.nomineeName:'',
          dob:ownerDriverSelected=='true'? values?.nomineeDetails?.nomineeDob:'',
          relationshipWithInsured:ownerDriverSelected=='true'
            ?values?.nomineeDetails?.relationshipWithNominee:'',
          nameOfAppointee: ownerDriverSelected=='true' ?values?.nomineeDetails?.nameOfAppointee:'',
          relationshipWithAppointee:ownerDriverSelected=='true'?
            values?.nomineeDetails?.relationshipWithAppointee:'',
        },
        customer: {
          id: buyMotorPolicy?.proposerDetails?.id,
          customerType: buyMotorPolicy?.proposerDetails?.customerType,
          isThinCustomer: false,
          title: buyMotorPolicy?.proposerDetails?.title,
          gender: buyMotorPolicy?.proposerDetails?.gender,
          firstName: buyMotorPolicy?.proposerDetails?.firstName,
          middleName: buyMotorPolicy?.proposerDetails?.middleName,
          lastName: buyMotorPolicy?.proposerDetails?.lastName,
          fullName: buyMotorPolicy?.proposerDetails?.fullName,
          proposerDOB: buyMotorPolicy?.proposerDetails?.proposerDOB,
          maritalStatus:
            buyMotorPolicy?.proposerDetails?.maritalStatus,
          occupation: buyMotorPolicy?.proposerDetails?.occupation,
          nationality: buyMotorPolicy?.proposerDetails?.nationality,
          idProofType: buyMotorPolicy?.proposerDetails?.idProofType,
          idProofNumber:
            buyMotorPolicy?.proposerDetails?.idProofNumber,
          panNumber: buyMotorPolicy?.proposerDetails?.panNumber,
          orgName: buyMotorPolicy?.proposerDetails?.orgName,
          orgType: buyMotorPolicy?.proposerDetails?.orgType,
          contactName: buyMotorPolicy?.proposerDetails?.contactName,
          regNumber: buyMotorPolicy?.proposerDetails?.regNumber,
          tanNumber: buyMotorPolicy?.proposerDetails?.tanNumber,
          gstNumber: buyMotorPolicy?.proposerDetails?.gstNumber,
          permAddressLine1:
            buyMotorPolicy?.proposerDetails?.permAddressLine1,
          permAddressLine2:
            buyMotorPolicy?.proposerDetails?.permAddressLine2,
          permAddressLine3:
            buyMotorPolicy?.proposerDetails?.permAddressLine3,
          permLandmark: buyMotorPolicy?.proposerDetails?.permLandmark,
          permPincode: buyMotorPolicy?.proposerDetails?.permPincode,
          permCityTownVillage:
            buyMotorPolicy?.proposerDetails?.permCityTownVillage,
          permDistrict: buyMotorPolicy?.proposerDetails?.permDistrict,
          permState: buyMotorPolicy?.proposerDetails?.permState,
          permCommAddressYN: buyMotorPolicy?.proposerDetails
            ?.permCommAddressYN
            ? true
            : false,
          commAddressLine1:
            buyMotorPolicy?.proposerDetails?.commAddressLine1,
          commAddressLine2:
            buyMotorPolicy?.proposerDetails?.commAddressLine2,
          commAddressLine3:
            buyMotorPolicy?.proposerDetails?.commAddressLine3,
          commLandmark: buyMotorPolicy?.proposerDetails?.commLandmark,
          commPincode: buyMotorPolicy?.proposerDetails?.commPincode,
          commCityTownVillage:
            buyMotorPolicy?.proposerDetails?.commCityTownVillage,
          commDistrict: buyMotorPolicy?.proposerDetails?.commDistrict,
          commState: buyMotorPolicy?.proposerDetails?.commState,
          phoneNo: buyMotorPolicy?.proposerDetails?.phoneNo,
          mobileNo: buyMotorPolicy?.proposerDetails?.mobileNo,
          emailID: buyMotorPolicy?.proposerDetails?.emailID,
          faxNo: buyMotorPolicy?.proposerDetails?.faxNo,
          altPhoneNo: buyMotorPolicy?.proposerDetails?.altPhoneNo,
          altMobileNo: buyMotorPolicy?.proposerDetails?.altMobileNo,
          ifscCode: buyMotorPolicy?.proposerDetailsMeta?.ifscCode,
          bankName: buyMotorPolicy?.proposerDetailsMeta?.bankName,
          branchName: buyMotorPolicy?.proposerDetailsMeta?.branchName,
          bankAcno: buyMotorPolicy?.proposerDetailsMeta?.bankAcno,
          accountHolderName:
            buyMotorPolicy?.proposerDetailsMeta?.accountHolderName,
          micrCode: buyMotorPolicy?.proposerDetailsMeta?.micrCode,
          employeeNumber:
            buyMotorPolicy?.proposerDetails?.employeeNumber,
        },
      },
    };
  };

  const onSubmit = async (values) => {
    if (!buyMotorPolicy?.proposalNumber
      || buyMotorPolicy?.isProposalModify //added
    ) {
      try {
        setParentAlerts([]);
        try{
            if(values?.documentDetails?.length > 0 
              && values?.documentDetails[0]?.documentBase64String
               && values?.documentDetails[0]?.documentBase64String?.length > 0 ){
              const uploadDocument = mutateQuery({
                mutation: UPLOAD_DOCUMENT,
                variables: {
                  input: {
                    uploadDocumentFor: {
                      proposalNumber: buyMotorPolicy?.quoteData?.quotationNo
                        ? buyMotorPolicy?.quoteData?.quotationNo : buyMotorPolicy?.quoteNumber 
                        ? buyMotorPolicy?.quoteNumber  : "",
                    },
                    documents:
                      values?.documentDetails?.map(
                        (document) => {
                          return {
                            documentName:
                              document?.documentName,
                            documentFileName:
                              document?.documentFileName,
                            documentExtension:
                              document?.documentExtension,
                            documentSize:
                              document?.documentSize,
                            documentBase64String:
                              document?.documentBase64String,
                            documentDescription:
                              document?.documentDescription,
                          };
                        },
                      ),
                  },
                },
              })
              // uploadDocuments({ });
              setLoadingStep(true);
              const { UploadDocData } = await uploadDocument;
              setLoadingStep(false);
            }else{
            }
        }catch(error){
          setLoadingStep(false);
          setCustomLoadingMessage(null);
          if(error?.message){
            if(error.message.includes("Unexpected token")){
              error.message='Please try again after sometime'
            }
          }
          setParentAlerts([
            {
              id: Date.now(),
              header: 'Error in Upload Document',
              content: (
                <div className="flex flex-col w-full h-full">
                  <Text type="normal">{error?.message}</Text>
                </div>
              ),
              type: 'error',
              timeout: null,
              disableClose: false,
            },
          ]);
          return false;
        }
        //SA975
        const calculatePremiumForProposalTWQuery = fetchQuery({
          query: (FOLLOW_API==='Y')?CALCULATE_PREMIUM_FOR_PROPOSAL_TWAPI
          :CALCULATE_PREMIUM_FOR_PROPOSAL_TW,
          variables: getCalculatePremiumForProposalVariables(values),
        });
        //EA975
        updateBuyMotorPolicy({
          additionalTabDetails: values,
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setCustomLoadingMessage('Calculating Premium');
        setLoadingStep(true);
        const { data } = await calculatePremiumForProposalTWQuery;
        setLoadingStep(false);
        setCustomLoadingMessage(null);
        //SA975
        if ((FOLLOW_API==='Y')?data?.calculatePremiumForProposalTWApi?.warningMsg:data?.gcvcalculatePremiumProposal?.warningMsg) {
          if (
            (FOLLOW_API==='Y')?(buyMotorPolicy?.premiumData?.finalpremium !== null &&
            buyMotorPolicy?.premiumData?.finalpremium?.toString() !==
              data?.calculatePremiumForProposalTWApi?.finalpremium?.toString()):
              (buyMotorPolicy?.premiumData?.totalPremium !== null &&
                buyMotorPolicy?.premiumData?.totalPremium?.toString() !==
                  data?.gcvcalculatePremiumProposal?.totalPremium?.toString())
        //EA975
          ) {
            setParentAlerts([
              {
                id: 1,
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      Your premium has been updated successfully
                    </Text>
                  </div>
                ),
                type: 'info',
                timeout: null,
                disableClose: false,
              },
              {
                id: 2,
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      {
                        //SA975
                        (FOLLOW_API==='Y')?(data?.calculatePremiumForProposalTWApi
                          ?.errormessage):(data?.gcvcalculatePremiumProposal
                            ?.warningMsg)
                        //SA975
                      }
                    </Text>
                  </div>
                ),
                type: 'warning',
                timeout: null,
                disableClose: false,
              },
            ]);
          } else if (
            buyMotorPolicy?.premiumData?.finalpremium === null || buyMotorPolicy?.premiumData?.totalPremium === null//SA975
          ) {
            setParentAlerts([
              {
                id: 1,
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      Your premium has been updated successfully
                    </Text>
                  </div>
                ),
                type: 'info',
                timeout: null,
                disableClose: false,
              },
              {
                id: 2,
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      {
                        //SA975
                        (FOLLOW_API==='Y')?(data?.calculatePremiumForProposalTWApi
                          ?.errormessage):(data?.gcvcalculatePremiumProposal
                            ?.warningMsg)
                        //EA975
                      }
                    </Text>
                  </div>
                ),
                type: 'warning',
                timeout: null,
                disableClose: false,
              },
            ]);
          } else {
            setParentAlerts([
              {
                id: Date.now(),
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      {
                        //SA975
                        (FOLLOW_API==='Y')?(data?.calculatePremiumForProposalTWApi
                          ?.errormessage):(data?.gcvcalculatePremiumProposal
                            ?.warningMsg)
                        //EA975
                      }
                    </Text>
                  </div>
                ),
                type: 'warning',
                timeout: null,
                disableClose: false,
              },
            ]);
          }
        } else {
          //SA975
          if (
            (FOLLOW_API==='Y')?(buyMotorPolicy?.premiumData?.finalpremium !== null &&
            buyMotorPolicy?.premiumData?.finalpremium?.toString() !==
              data?.calculatePremiumForProposalTWApi?.finalpremium?.toString()):
              (buyMotorPolicy?.premiumData?.totalPremium !== null &&
                buyMotorPolicy?.premiumData?.totalPremium?.toString() !==
                  data?.gcvcalculatePremiumProposal?.totalPremium?.toString())
          //EA975
          ) {
            setParentAlerts([
              {
                id: Date.now(),
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      Your premium has been updated successfully
                    </Text>
                  </div>
                ),
                type: 'info',
                timeout: null,
                disableClose: false,
              },
            ]);
          } else if (
            buyMotorPolicy?.premiumData?.finalpremium === null || buyMotorPolicy?.premiumData?.totalPremium === null//SA975
          ) {
            setParentAlerts([
              {
                id: Date.now(),
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      Your premium has been updated successfully
                    </Text>
                  </div>
                ),
                type: 'info',
                timeout: null,
                disableClose: false,
              },
            ]);
          } else {
            setParentAlerts([]);
          }
        }
        //SA975
        (FOLLOW_API==='Y')?(updateBuyMotorPolicy({
          premiumData: {
            ...data?.calculatePremiumForProposalTWApi,
            tenure:
              buyMotorPolicy?.quoteData?.tenure ||
              buyMotorPolicy?.quoteData?.premiumData?.tenure,
          },
          policy: {
            startDate: data?.calculatePremiumForProposalTWApi?.p_startdate,
            //  buyMotorPolicy?.businessType?.toLowerCase() === 'roll over'
            //   ? startDate_min
            //   : "",
            endDate: '',
            time: '',
          },
        })):(updateBuyMotorPolicy({
          premiumData: {
            ...data?.gcvcalculatePremiumProposal,
            tenure:
              buyMotorPolicy?.quoteData?.tenure ||
              buyMotorPolicy?.quoteData?.premiumData?.tenure,
          },
          policy: {
            startDate:data?.gcvcalculatePremiumProposal?.p_startdate,
              // ? startDate_min
              // : "",
            endDate: '',
            time: '',
          },
        }));
        //EA975
        return true;
      } catch (error) {
        setLoadingStep(false);
        setCustomLoadingMessage(null);
        //SA radhika
        if(error?.message){
          if(error.message.includes("Unexpected token")){
            error.message='Please try again after sometime'
          }
        }
        //EA radhika
        setParentAlerts([
          {
            id: Date.now(),
            header: 'Error calculating premium',
            content: (
              <div className="flex flex-col w-full h-full">
                <Text type="normal">{error?.message}</Text>
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        return false;
      }
    } else {
      return true;
    }
  };

  return (
    <div>
      <QuantaFormik
        innerRef={props.forwardedRef}
        enableReinitialize={true}
        {...{
          initialValues,
          validate,
          onSubmit,
          validator: () => ({}),
        }}
      >
        <AdditionalDetailform {...{ validate ,
         
          }} />
      </QuantaFormik>
    </div>
  );
}
